import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: string;
  DateTime: string;
  JSON: any;
  SafeInt: number;
};

export type AccountingFirmInput = {
  accountingFirmName?: InputMaybe<Scalars['String']>;
  hasAccountingFirm?: InputMaybe<Scalars['Boolean']>;
};

export type AddBeneficialOwnerInput = {
  name: Scalars['String'];
  shareInPts: Scalars['Float'];
  yearOfBirth: Scalars['String'];
};

export type AddEmissionProcessMeetingNoteInput = {
  emissionProcessId?: InputMaybe<Scalars['ID']>;
  meetingId?: InputMaybe<Scalars['ID']>;
  note: Scalars['String'];
};

export type AddressInput = {
  countryCode?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  postalTown?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
};

export enum ApprovalCommitSection {
  ACCOUNTING = 'ACCOUNTING',
  ALL = 'ALL',
  CAMPAIGN_CARD = 'CAMPAIGN_CARD'
}

export enum ApprovalCommitStatus {
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
  REQUEST_APPROVAL = 'REQUEST_APPROVAL'
}

export enum ArrayDirection {
  DOWN = 'DOWN',
  UP = 'UP'
}

export type AuditorInput = {
  hasCompanyAuditor?: InputMaybe<Scalars['Boolean']>;
  isCompanySubjectToAudit?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type CarouselItemInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  animated?: InputMaybe<Scalars['Boolean']>;
  backgroundImageFileId?: InputMaybe<Scalars['String']>;
  buttonUrl?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  darkThemed?: InputMaybe<Scalars['Boolean']>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  subheader?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export enum CommentEventType {
  CREATED = 'CREATED',
  EDITED = 'EDITED',
  VISIBILITY_SET = 'VISIBILITY_SET'
}

export type CommentInput = {
  content: Scalars['String'];
  path?: InputMaybe<Scalars['String']>;
  visibility: CommentVisibility;
};

export type CommentParentInput = {
  id: Scalars['ID'];
  type: CommentParentType;
};

export enum CommentParentType {
  EMISSION_PROCESS = 'EMISSION_PROCESS'
}

export enum CommentVisibility {
  EXTERNAL = 'EXTERNAL',
  HIDDEN = 'HIDDEN',
  INTERNAL = 'INTERNAL'
}

export enum Committer {
  FACILITATOR = 'FACILITATOR',
  ISSUER = 'ISSUER'
}

export type CompanySearchInput = {
  pageSize?: InputMaybe<Scalars['Int']>;
  searchStr?: InputMaybe<Scalars['String']>;
};

export type ConflictsOfInterestInputs = {
  assessmentOfRiskFactors?: InputMaybe<RiskItemInput>;
  concurrentIssues?: InputMaybe<RiskItemInput>;
  desireForQuickProcess?: InputMaybe<RiskItemInput>;
  interestInIssuer?: InputMaybe<RiskItemInput>;
  lackOfTransparency?: InputMaybe<RiskItemInput>;
  productionOfEconomicConditions?: InputMaybe<RiskItemInput>;
  propensityToProduceInvestment?: InputMaybe<RiskItemInput>;
  valuationOfOwnBusiness?: InputMaybe<RiskItemInput>;
};

export type ContactPersonInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
};

export type ContractApplicationConvertibleLoanInput = {
  amount?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
};

export type ContractApplicationInput = {
  assumedPreallocatedAmount?: InputMaybe<Scalars['SafeInt']>;
  ceoName?: InputMaybe<Scalars['String']>;
  chairmanName?: InputMaybe<Scalars['String']>;
  companyDescription?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  companyValuation?: InputMaybe<Scalars['SafeInt']>;
  contactEmail: Scalars['String'];
  contactName: Scalars['String'];
  contactPhone?: InputMaybe<PhoneNumberInput>;
  convertibleLoansOptions: Array<ContractApplicationConvertibleLoanInput>;
  estimatedTimePeriod?: InputMaybe<EstimatedTimePeriod>;
  fundraisingTarget?: InputMaybe<Scalars['SafeInt']>;
  incomeCurrentFiscal?: InputMaybe<Scalars['SafeInt']>;
  incomePreviousFiscal?: InputMaybe<Scalars['SafeInt']>;
  incubator?: InputMaybe<IncubatorInput>;
  numberOfEmployees?: InputMaybe<Scalars['Int']>;
  numberOfShares?: InputMaybe<Scalars['Int']>;
  organizationNumber?: InputMaybe<Scalars['String']>;
  otherInvestments?: InputMaybe<Scalars['SafeInt']>;
  otherInvestmentsDescription?: InputMaybe<Scalars['String']>;
  paidUpCapital?: InputMaybe<Scalars['SafeInt']>;
  shareCapital?: InputMaybe<Scalars['SafeInt']>;
  shareCapitalFromTeamAndStaff?: InputMaybe<Scalars['SafeInt']>;
  shareholdersAgreement?: InputMaybe<Scalars['Boolean']>;
  softFunding?: InputMaybe<Scalars['SafeInt']>;
};

export enum ContractApplicationStatusEnum {
  NOT_SUBMITTED = 'NOT_SUBMITTED',
  REJECTED = 'REJECTED',
  SUBMITTED = 'SUBMITTED'
}

export type ConvertibleLoanInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
  numberOfShares: Scalars['Int'];
  orgNumber: Scalars['String'];
  pricePerShare: Scalars['Int'];
};

export type CreateDiscussionThreadInput = {
  content: Scalars['String'];
  subscribed: Scalars['Boolean'];
  title: Scalars['String'];
};

export type CreateEmissionProcessContractInput = {
  contractFile: Scalars['String'];
  contractId: Scalars['ID'];
  facilitatorSignatures: Array<Scalars['ID']>;
  issuerSignatures: Array<Scalars['ID']>;
};

export type CreateEmissionProcessContributorInput = {
  email: Scalars['String'];
  receiveNotifications: Scalars['Boolean'];
};

export type CreateEmissionProcessMeetingInput = {
  emissionProcessId: Scalars['ID'];
  employeeIds?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
};

export type CreateLeadOrganizationInput = {
  companyName: Scalars['String'];
  contactEmail: Scalars['String'];
  contactName: Scalars['String'];
  organizationNumber: Scalars['String'];
};

export enum CreditCheck {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E'
}

export type CroppedImageInput = {
  cropped: Scalars['String'];
  original: Scalars['String'];
};

export type DeclarationOfCompletenessInput = {
  contributorIds: Array<Scalars['ID']>;
};

export enum DocumentTemplateType {
  BUDGET_PROGNOSIS = 'BUDGET_PROGNOSIS',
  STATUTES_CHANGES = 'STATUTES_CHANGES',
  VALUATION_DOCUMENT = 'VALUATION_DOCUMENT'
}

export enum EmailTemplateSection {
  INTERNAL = 'INTERNAL',
  INVESTOR = 'INVESTOR',
  ISSUER = 'ISSUER'
}

export enum EmailTemplateType {
  ACCOUNTING_APPROVED = 'ACCOUNTING_APPROVED',
  ACCOUNTING_REJECTED = 'ACCOUNTING_REJECTED',
  AML_100K = 'AML_100K',
  APPLICATION_OPEN = 'APPLICATION_OPEN',
  CAMPAIGN_CARD_APPROVED = 'CAMPAIGN_CARD_APPROVED',
  CAMPAIGN_CARD_REJECTED = 'CAMPAIGN_CARD_REJECTED',
  CAMPAIGN_TOOL_OPENED = 'CAMPAIGN_TOOL_OPENED',
  CONTRACT_APPLICATION_SUBMITTED_CONFIRMATION = 'CONTRACT_APPLICATION_SUBMITTED_CONFIRMATION',
  CUSTOMER_AGREEMENT = 'CUSTOMER_AGREEMENT',
  DECLARATION_OF_COMPLETENESS = 'DECLARATION_OF_COMPLETENESS',
  DISCUSSION_COMMENT = 'DISCUSSION_COMMENT',
  DISCUSSION_THREAD = 'DISCUSSION_THREAD',
  EMISSION_PROCESS_CONTRIBUTOR = 'EMISSION_PROCESS_CONTRIBUTOR',
  EMISSION_PROCESS_OWNER = 'EMISSION_PROCESS_OWNER',
  FOLLOWING_CONFIRMATION_WITHOUT_USER_PROFILE = 'FOLLOWING_CONFIRMATION_WITHOUT_USER_PROFILE',
  FOLLOWING_CONFIRMATION_WITH_USER_PROFILE = 'FOLLOWING_CONFIRMATION_WITH_USER_PROFILE',
  INVESTMENT_OFFER_APPROVED = 'INVESTMENT_OFFER_APPROVED',
  INVESTMENT_OFFER_REJECTED = 'INVESTMENT_OFFER_REJECTED',
  INVESTMENT_OFFER_SUBSCRIPTION_WINDOW_CLOSING_NOT_SUCCESSFUL = 'INVESTMENT_OFFER_SUBSCRIPTION_WINDOW_CLOSING_NOT_SUCCESSFUL',
  INVESTMENT_OFFER_SUBSCRIPTION_WINDOW_CLOSING_SUCCESSFUL = 'INVESTMENT_OFFER_SUBSCRIPTION_WINDOW_CLOSING_SUCCESSFUL',
  INVESTMENT_OFFER_SUBSCRIPTION_WINDOW_OPENING = 'INVESTMENT_OFFER_SUBSCRIPTION_WINDOW_OPENING',
  MISSING_VPS_ACCOUNT_REMINDER = 'MISSING_VPS_ACCOUNT_REMINDER',
  RESERVED_SUBSCRIPTION_PAYMENT_INFO = 'RESERVED_SUBSCRIPTION_PAYMENT_INFO',
  RESERVED_SUBSCRIPTION_PAYMENT_REMINDER = 'RESERVED_SUBSCRIPTION_PAYMENT_REMINDER',
  RESERVED_SUBSCRIPTION_RECEIPT = 'RESERVED_SUBSCRIPTION_RECEIPT',
  RESERVED_SUBSCRIPTION_RECEIPT_VALIDATION = 'RESERVED_SUBSCRIPTION_RECEIPT_VALIDATION',
  VALIDATION_PHASE_STARTED = 'VALIDATION_PHASE_STARTED'
}

export enum EmissionProcessActivityPhase {
  APPROVAL_FINISHED = 'APPROVAL_FINISHED',
  APPROVE_SHAREHOLDERS = 'APPROVE_SHAREHOLDERS',
  COMPLETED = 'COMPLETED',
  CONTRACT_APPLICATION_CREATED = 'CONTRACT_APPLICATION_CREATED',
  CONTRACT_APPLICATION_SUBMITTED = 'CONTRACT_APPLICATION_SUBMITTED',
  CUSTOMER_AGREEMENT_CREATED = 'CUSTOMER_AGREEMENT_CREATED',
  CUSTOMER_AGREEMENT_SIGNED = 'CUSTOMER_AGREEMENT_SIGNED',
  DECLARATION_OF_COMPLETENESS_CREATED = 'DECLARATION_OF_COMPLETENESS_CREATED',
  DECLARATION_OF_COMPLETENESS_SIGNED = 'DECLARATION_OF_COMPLETENESS_SIGNED',
  DESIGNING_EMISSION = 'DESIGNING_EMISSION',
  FAILED = 'FAILED',
  MANDATE_REQUESTED = 'MANDATE_REQUESTED',
  MANDATE_SET = 'MANDATE_SET',
  NONE = 'NONE',
  OPEN_SUBSCRIPTIONS_WINDOW = 'OPEN_SUBSCRIPTIONS_WINDOW',
  PENDING_ACCOUNTING_SECTION_APPROVAL = 'PENDING_ACCOUNTING_SECTION_APPROVAL',
  PENDING_ALL_SECTIONS_APPROVAL = 'PENDING_ALL_SECTIONS_APPROVAL',
  PENDING_EMISSION_CARD_SECTION_APPROVAL = 'PENDING_EMISSION_CARD_SECTION_APPROVAL',
  PENDING_GA_PROTOCOL = 'PENDING_GA_PROTOCOL',
  PENDING_GA_PROTOCOL_APPROVAL = 'PENDING_GA_PROTOCOL_APPROVAL',
  PENDING_PAYMENT_INFO_SENT = 'PENDING_PAYMENT_INFO_SENT',
  PENDING_UPDATED_CERTIFICATE = 'PENDING_UPDATED_CERTIFICATE',
  PENDING_UPDATED_CERTIFICATE_APPROVAL = 'PENDING_UPDATED_CERTIFICATE_APPROVAL',
  PREORDER_SUBSCRIPTIONS = 'PREORDER_SUBSCRIPTIONS',
  REGISTER_PAYMENTS = 'REGISTER_PAYMENTS',
  RISK_EVALUATION_CREATED = 'RISK_EVALUATION_CREATED',
  RISK_EVALUATION_SIGNED = 'RISK_EVALUATION_SIGNED',
  TERMINATED = 'TERMINATED',
  UNKNOWN_STATUS = 'UNKNOWN_STATUS',
  UPDATED_CERTIFICATE_APPROVED = 'UPDATED_CERTIFICATE_APPROVED',
  VALIDATION_SUBSCRIPTIONS = 'VALIDATION_SUBSCRIPTIONS',
  VALIDATION_SUBSCRIPTIONS_GOAL_REACHED = 'VALIDATION_SUBSCRIPTIONS_GOAL_REACHED'
}

export enum EmissionProcessContributorType {
  CONTRIBUTOR = 'CONTRIBUTOR',
  OWNER = 'OWNER'
}

export enum EmissionProcessLabel {
  CANCELLED = 'CANCELLED',
  COLD = 'COLD',
  COMPLETED = 'COMPLETED',
  NEW = 'NEW',
  PROSPECT = 'PROSPECT',
  WARM = 'WARM'
}

export enum EmissionProcessMeetingType {
  ACCOUNTING = 'ACCOUNTING',
  GENERIC = 'GENERIC',
  INTRODUCTION = 'INTRODUCTION',
  KICKOFF = 'KICKOFF',
  MARKETING = 'MARKETING',
  STATUS = 'STATUS'
}

export enum EmissionRunwayEnum {
  OVER_SIX = 'OVER_SIX',
  THREE_TO_SIX = 'THREE_TO_SIX',
  UNDER_THREE = 'UNDER_THREE'
}

export enum EmissionSoftFundingInstitutionsEnum {
  INNOVATION_NORWAY = 'INNOVATION_NORWAY',
  OTHER = 'OTHER',
  RESEARCH_COUNCIL = 'RESEARCH_COUNCIL'
}

export enum EmissionStatusEnum {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  ONGOING = 'ONGOING'
}

export enum ErrorCodeEnum {
  ADMIN_REQUIRED = 'ADMIN_REQUIRED',
  ALREADY_EXISTS = 'ALREADY_EXISTS',
  ARCHIVED = 'ARCHIVED',
  BAD_REQUEST = 'BAD_REQUEST',
  BANKID_REQUIRED = 'BANKID_REQUIRED',
  EXPIRED = 'EXPIRED',
  FORBIDDEN = 'FORBIDDEN',
  INVALID_ACTION = 'INVALID_ACTION',
  LOGIN_REQUIRED = 'LOGIN_REQUIRED',
  NOT_FOUND = 'NOT_FOUND'
}

export enum EstimatedTimePeriod {
  GREATER_THAN_SIX_MONTHS = 'GREATER_THAN_SIX_MONTHS',
  LESS_THAN_THREE_MONTHS = 'LESS_THAN_THREE_MONTHS',
  THREE_TO_SIX_MONTHS = 'THREE_TO_SIX_MONTHS'
}

export enum EvaluatedRisk {
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM'
}

export enum ExpectedPositiveOperatingResultEnum {
  ONE_TO_TWO = 'ONE_TO_TWO',
  OVER_FIVE = 'OVER_FIVE',
  THREE_TO_FIVE = 'THREE_TO_FIVE',
  TODAY = 'TODAY'
}

export type FiRatingInputs = {
  activitiesConsideredLegal?: InputMaybe<Scalars['Boolean']>;
  clearCommunicationAndInformation?: InputMaybe<Scalars['Boolean']>;
  noMLOrTerrorismFinancing?: InputMaybe<Scalars['Boolean']>;
  noSignificantCashUse?: InputMaybe<Scalars['Boolean']>;
  notInConstruction?: InputMaybe<Scalars['Boolean']>;
  notInFishing?: InputMaybe<Scalars['Boolean']>;
  notInRealEstateDevelopment?: InputMaybe<Scalars['Boolean']>;
  withinLowCorruptionAndCrimeCountry?: InputMaybe<Scalars['Boolean']>;
};

export type FileUploadInitInput = {
  mimeType: Scalars['String'];
  name: Scalars['String'];
  path: Scalars['String'];
  ref: Scalars['String'];
  size: Scalars['Int'];
};

export type FileUploadResponseInput = {
  id: Scalars['String'];
  statusCode: Scalars['Int'];
};

export type FinishedCampaignCardsFilterInput = {
  text?: InputMaybe<Scalars['String']>;
};

export type GenerateEmissionConfigInput = {
  emissionShouldFail?: InputMaybe<Scalars['Boolean']>;
  estimatedValuation?: InputMaybe<Scalars['SafeInt']>;
  fastFill?: InputMaybe<Scalars['Boolean']>;
  fillSections?: InputMaybe<Array<InputMaybe<GenerateEmissionConfigSection>>>;
  settingsToggled?: InputMaybe<Array<InputMaybe<InvestmentOfferSettingsType>>>;
  step: GenerateEmissionConfigOptionStep;
};

export enum GenerateEmissionConfigOptionStep {
  ADD_FOLLOWERS = 'ADD_FOLLOWERS',
  APPROVE_ACCOUNTING = 'APPROVE_ACCOUNTING',
  APPROVE_AND_PUBLISH_CAMPAIGN_CARD = 'APPROVE_AND_PUBLISH_CAMPAIGN_CARD',
  APPROVE_INVESTMENT_OFFER = 'APPROVE_INVESTMENT_OFFER',
  APPROVE_SUBSCRIPTION_LIST = 'APPROVE_SUBSCRIPTION_LIST',
  CLOSE_SUBSCRIPTION_WINDOW = 'CLOSE_SUBSCRIPTION_WINDOW',
  COMPLETE_CUSTOMER_AGREEMENT = 'COMPLETE_CUSTOMER_AGREEMENT',
  COMPLETE_DECLARATION_OF_COMPLETENESS = 'COMPLETE_DECLARATION_OF_COMPLETENESS',
  CREATE_CONTRACT_APPLICATION = 'CREATE_CONTRACT_APPLICATION',
  FILL_CONTRACT_APPLICATION = 'FILL_CONTRACT_APPLICATION',
  FILL_RISK_EVALUATION = 'FILL_RISK_EVALUATION',
  FILL_SECTIONS = 'FILL_SECTIONS',
  GENERATE_INVESTORS_AND_FILL_RESERVATION_LIST = 'GENERATE_INVESTORS_AND_FILL_RESERVATION_LIST',
  GENERATE_INVESTORS_AND_FILL_VALIDATION_PHASE = 'GENERATE_INVESTORS_AND_FILL_VALIDATION_PHASE',
  GRANT_ISSUER_ACCESS = 'GRANT_ISSUER_ACCESS',
  MARK_ALL_SUBSCRIPTIONS_AS_PAID = 'MARK_ALL_SUBSCRIPTIONS_AS_PAID',
  PUBLISH_INVESTMENT_OFFER = 'PUBLISH_INVESTMENT_OFFER',
  SEND_PAYMENT_INFO = 'SEND_PAYMENT_INFO',
  SET_MANDATE = 'SET_MANDATE',
  SIGN_RISK_EVALUATION = 'SIGN_RISK_EVALUATION',
  START_RISK_EVALUATION = 'START_RISK_EVALUATION',
  START_SUBSCRIPTION_WINDOW = 'START_SUBSCRIPTION_WINDOW',
  START_VALIDATION_PHASE = 'START_VALIDATION_PHASE',
  SUBMIT_AND_APPROVE_GA_PROTOCOL = 'SUBMIT_AND_APPROVE_GA_PROTOCOL',
  SUBMIT_AND_APPROVE_UPDATED_CERTIFICATE = 'SUBMIT_AND_APPROVE_UPDATED_CERTIFICATE',
  SUBMIT_CONTRACT_APPLICATION = 'SUBMIT_CONTRACT_APPLICATION'
}

export enum GenerateEmissionConfigSection {
  ACCOUNTING = 'ACCOUNTING',
  ALL = 'ALL',
  CAMPAIGN_CARD = 'CAMPAIGN_CARD',
  DOCUMENTS = 'DOCUMENTS',
  EMISSION = 'EMISSION',
  LOAN_CONVERSIONS = 'LOAN_CONVERSIONS',
  PRESENTATION = 'PRESENTATION',
  SHAREHOLDERS = 'SHAREHOLDERS',
  SINGLE_PURPOSE_VEHICLE = 'SINGLE_PURPOSE_VEHICLE',
  TEAM_AND_NETWORK = 'TEAM_AND_NETWORK'
}

export enum GenerateEmissionCurrentStep {
  ADDING_FOLLOWERS = 'ADDING_FOLLOWERS',
  APPROVING_ACCOUNTING_SECTION = 'APPROVING_ACCOUNTING_SECTION',
  APPROVING_AND_PUBLISHING_CAMPAIGN_CARD_SECTION = 'APPROVING_AND_PUBLISHING_CAMPAIGN_CARD_SECTION',
  APPROVING_INVESTMENT_OFFER = 'APPROVING_INVESTMENT_OFFER',
  APPROVING_SUBSCRIPTION_LIST = 'APPROVING_SUBSCRIPTION_LIST',
  CLOSING_SUBSCRIPTION_WINDOW = 'CLOSING_SUBSCRIPTION_WINDOW',
  CREATING_EMISSION_PROCESS = 'CREATING_EMISSION_PROCESS',
  DEFINING_DEFAULT_FILES = 'DEFINING_DEFAULT_FILES',
  DONE = 'DONE',
  FETCHING_USER_OBJECTS = 'FETCHING_USER_OBJECTS',
  GENERATING_CONTRACT_APPLICATION = 'GENERATING_CONTRACT_APPLICATION',
  GENERATING_CUSTOMER_AGREEMENT = 'GENERATING_CUSTOMER_AGREEMENT',
  GENERATING_DECLARATION_OF_COMPLETENESS = 'GENERATING_DECLARATION_OF_COMPLETENESS',
  GENERATING_ISSUER_ACCESS = 'GENERATING_ISSUER_ACCESS',
  GENERATING_LEAD = 'GENERATING_LEAD',
  GENERATING_MANDATE = 'GENERATING_MANDATE',
  GENERATING_RISK_EVALUATION = 'GENERATING_RISK_EVALUATION',
  GENERATING_SECTION_ACCOUNTING = 'GENERATING_SECTION_ACCOUNTING',
  GENERATING_SECTION_CAMPAIGN_CARD = 'GENERATING_SECTION_CAMPAIGN_CARD',
  GENERATING_SECTION_DOCUMENTS = 'GENERATING_SECTION_DOCUMENTS',
  GENERATING_SECTION_EMISSION = 'GENERATING_SECTION_EMISSION',
  GENERATING_SECTION_LOAN_CONVERSIONS = 'GENERATING_SECTION_LOAN_CONVERSIONS',
  GENERATING_SECTION_PRESENTATION = 'GENERATING_SECTION_PRESENTATION',
  GENERATING_SECTION_SHAREHOLDERS = 'GENERATING_SECTION_SHAREHOLDERS',
  GENERATING_SECTION_SINGLE_PURPOSE_VEHICLE = 'GENERATING_SECTION_SINGLE_PURPOSE_VEHICLE',
  GENERATING_SECTION_TEAM_AND_NETWORK = 'GENERATING_SECTION_TEAM_AND_NETWORK',
  INITIALIZING_GENERATOR = 'INITIALIZING_GENERATOR',
  MARKING_ALL_SUBSCRIPTIONS_AS_PAID = 'MARKING_ALL_SUBSCRIPTIONS_AS_PAID',
  PUBLISHING_INVESTMENT_OFFER = 'PUBLISHING_INVESTMENT_OFFER',
  RESERVING_ABOVE_MINIMUM_SUBSCRIPTIONS = 'RESERVING_ABOVE_MINIMUM_SUBSCRIPTIONS',
  RESERVING_BELOW_MINIMUM_SUBSCRIPTIONS = 'RESERVING_BELOW_MINIMUM_SUBSCRIPTIONS',
  RESERVING_VALIDATION_AMOUNT = 'RESERVING_VALIDATION_AMOUNT',
  SENDING_PAYMENT_INFO = 'SENDING_PAYMENT_INFO',
  STARTING_SUBSCRIPTION_WINDOW = 'STARTING_SUBSCRIPTION_WINDOW',
  STARTING_VALIDATION_PHASE = 'STARTING_VALIDATION_PHASE',
  SUBMITING_AND_APPROVING_UPDATED_CERTIFICATE = 'SUBMITING_AND_APPROVING_UPDATED_CERTIFICATE',
  SUBMITTING_AND_APPROVING_GA_PROTOCOL = 'SUBMITTING_AND_APPROVING_GA_PROTOCOL'
}

export type GenerateEmissionInput = {
  config: GenerateEmissionConfigInput;
  userId: Scalars['ID'];
};

export type IncubatorInput = {
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type InvestmentOfferDatesInput = {
  publicSubscriptionsCloseDate: Scalars['DateTime'];
  publicSubscriptionsOpenDate: Scalars['DateTime'];
  publishDate: Scalars['DateTime'];
};

export type InvestmentOfferFieldReviewInput = {
  review: InvestmentOfferReviewInput;
  section: Scalars['String'];
};

export type InvestmentOfferFollowerInput = {
  acceptsPreorderOffer: Scalars['Boolean'];
  email: Scalars['String'];
};

export enum InvestmentOfferInformationEvent {
  FIELD_UPDATE = 'FIELD_UPDATE',
  SECTION_UPDATE = 'SECTION_UPDATE'
}

export type InvestmentOfferPresentationFieldInput = {
  data?: InputMaybe<Scalars['String']>;
  key: Scalars['String'];
  label?: InputMaybe<Scalars['String']>;
};

export type InvestmentOfferPresentationInput = {
  coverImage?: InputMaybe<CroppedImageInput>;
  video?: InputMaybe<Scalars['String']>;
  videoThumbnail?: InputMaybe<CroppedImageInput>;
};

export type InvestmentOfferReviewInput = {
  approved: Scalars['Boolean'];
  field: Scalars['String'];
  reason?: InputMaybe<Scalars['String']>;
  subField?: InputMaybe<Scalars['String']>;
};

export type InvestmentOfferSettingsInput = {
  type: InvestmentOfferSettingsType;
  value: Scalars['Boolean'];
};

export enum InvestmentOfferSettingsType {
  SINGLE_PURPOSE_VEHICLE_ENABLED = 'SINGLE_PURPOSE_VEHICLE_ENABLED',
  VPS_ENABLED = 'VPS_ENABLED'
}

export enum InvestmentOfferStepStatusEnum {
  APPROVED = 'APPROVED',
  CHANGES_REQUESTED = 'CHANGES_REQUESTED',
  ERROR = 'ERROR',
  IN_PROGRESS = 'IN_PROGRESS',
  REVIEW = 'REVIEW'
}

export type IoInfoAdditionalDocumentInput = {
  id: Scalars['ID'];
  isHidden: Scalars['Boolean'];
  shouldBePublished: Scalars['Boolean'];
  title: Scalars['String'];
};

export type IoInfoDocumentInput = {
  fileId: Scalars['String'];
  shouldBePublished: Scalars['Boolean'];
};

export enum LeadState {
  LOST = 'LOST',
  NEW = 'NEW',
  WON = 'WON'
}

export enum MandateConclusionEnum {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED'
}

export enum MandateDecision {
  NO = 'NO',
  UNSURE = 'UNSURE',
  YES = 'YES'
}

export enum MandateStatus {
  APPROVED = 'APPROVED',
  IN_PROGRESS = 'IN_PROGRESS',
  REJECTED = 'REJECTED',
  SENT_FOR_APPROVAL = 'SENT_FOR_APPROVAL'
}

export type ManualAmlSearchesPaginationInput = {
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDir?: InputMaybe<Scalars['String']>;
};

export type MissionCriticalAgreementInput = {
  agreement?: InputMaybe<IoInfoDocumentInput>;
  explanation?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type OptionalOrganizationInput = {
  name?: InputMaybe<Scalars['String']>;
  organizationNumber?: InputMaybe<Scalars['String']>;
};

export type PageOfReservedSubscriptionsFilterInput = {
  createdAt?: InputMaybe<Array<InputMaybe<Scalars['SafeInt']>>>;
  emissionProcessId?: InputMaybe<Scalars['String']>;
  emissionTitle?: InputMaybe<Scalars['String']>;
  hideInvalidSubscriptions?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  signeeEmail?: InputMaybe<Scalars['String']>;
  signeeName?: InputMaybe<Scalars['String']>;
};

export type PaginationInput = {
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

export enum PaymentTarget {
  SINGLE_PURPOSE_VEHICLE = 'SINGLE_PURPOSE_VEHICLE',
  TARGET_COMPANY = 'TARGET_COMPANY'
}

export type PerformAmlCheckInput = {
  dateOfBirth?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type PhoneNumberInput = {
  country: Scalars['String'];
  number: Scalars['String'];
};

export enum PostCampaignDocumentTarget {
  SINGLE_PURPOSE_VEHICLE = 'SINGLE_PURPOSE_VEHICLE',
  TARGET_COMPANY = 'TARGET_COMPANY'
}

export enum ProcessStepEnum {
  CONTRACT_APPLICATION = 'CONTRACT_APPLICATION',
  INFO_MEETING = 'INFO_MEETING',
  INVESTMENT_OFFER = 'INVESTMENT_OFFER',
  PUBLISHED_OFFER = 'PUBLISHED_OFFER'
}

export enum ProcessStepStatusEnum {
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED',
  POST_CAMPAIGN = 'POST_CAMPAIGN',
  REVIEW = 'REVIEW',
  SUBSCRIPTIONS_OPEN = 'SUBSCRIPTIONS_OPEN',
  UNAVAILABLE = 'UNAVAILABLE'
}

export enum PublicCampaignPhase {
  APPROVE_SHAREHOLDERS = 'APPROVE_SHAREHOLDERS',
  COMPLETED_EMISSION = 'COMPLETED_EMISSION',
  FAILED = 'FAILED',
  NOT_YET_PUBLIC = 'NOT_YET_PUBLIC',
  OPEN_SUBSCRIPTIONS_WINDOW = 'OPEN_SUBSCRIPTIONS_WINDOW',
  PENDING_GA_PROTOCOL = 'PENDING_GA_PROTOCOL',
  PENDING_GA_PROTOCOL_APPROVAL = 'PENDING_GA_PROTOCOL_APPROVAL',
  PENDING_PAYMENT_INFO_SENT = 'PENDING_PAYMENT_INFO_SENT',
  PENDING_UPDATED_CERTIFICATE = 'PENDING_UPDATED_CERTIFICATE',
  PENDING_UPDATED_CERTIFICATE_APPROVAL = 'PENDING_UPDATED_CERTIFICATE_APPROVAL',
  PREORDER_SUBSCRIPTIONS = 'PREORDER_SUBSCRIPTIONS',
  REGISTER_PAYMENTS = 'REGISTER_PAYMENTS',
  UPDATED_CERTIFICATE_APPROVED = 'UPDATED_CERTIFICATE_APPROVED',
  VALIDATION_SUBSCRIPTIONS = 'VALIDATION_SUBSCRIPTIONS'
}

export enum PublishedCampaignCardState {
  ARCHIVED = 'ARCHIVED',
  COMING_SOON = 'COMING_SOON',
  FINISHED = 'FINISHED',
  ONGOING = 'ONGOING',
  UPCOMING = 'UPCOMING'
}

export enum QueueJobType {
  MISSING_VPS_ACCOUNT_REMINDER = 'MISSING_VPS_ACCOUNT_REMINDER',
  OVER_100K_INVESTMENTS_CHECK = 'OVER_100K_INVESTMENTS_CHECK',
  POST_RESERVATION_AML = 'POST_RESERVATION_AML',
  RESERVED_SUBSCRIPTIONS_PAYMENT_REMINDER = 'RESERVED_SUBSCRIPTIONS_PAYMENT_REMINDER',
  RESERVED_SUBSCRIPTIONS_RECEIPT = 'RESERVED_SUBSCRIPTIONS_RECEIPT',
  RESERVED_SUBSCRIPTION_PAYMENT_INFO = 'RESERVED_SUBSCRIPTION_PAYMENT_INFO',
  SUBCRIPTION_WINDOW_CLOSING = 'SUBCRIPTION_WINDOW_CLOSING',
  SUBCRIPTION_WINDOW_OPENING = 'SUBCRIPTION_WINDOW_OPENING'
}

export type RegisterEmissionProcessFilesInput = {
  emissionProcessId: Scalars['String'];
  fileId: Scalars['String'];
};

export type RejectContractApplicationInput = {
  leadId: Scalars['ID'];
  rejectedReason: Scalars['String'];
};

export type ReputationRiskInput = {
  issuerReputationRisk: RiskItemInput;
};

export enum ReserveSubscriptionConsent {
  CHAIRMAN_AUTHORIZATION = 'CHAIRMAN_AUTHORIZATION',
  CREATE_VPS_ACCOUNT = 'CREATE_VPS_ACCOUNT',
  IGNORE_EXPEDIENCY = 'IGNORE_EXPEDIENCY',
  NOT_INVESTMENT_ADVICE = 'NOT_INVESTMENT_ADVICE',
  RISK_ACCEPTED = 'RISK_ACCEPTED',
  SHAREHOLDER_AGREEMENT = 'SHAREHOLDER_AGREEMENT',
  SINGLE_PURPOSE_VEHICLE = 'SINGLE_PURPOSE_VEHICLE',
  WITHIN_VALIDATION_AMOUNT = 'WITHIN_VALIDATION_AMOUNT'
}

export type ReserveSubscriptionInput = {
  consents: Array<ReserveSubscriptionConsent>;
  expediencyTestId: Scalars['String'];
  numberOfShares: Scalars['Int'];
};

export enum ReservedSubscriptionTag {
  BOARD = 'BOARD',
  FAMILY = 'FAMILY',
  OWNER = 'OWNER',
  TEAM = 'TEAM',
  TOP_TEN = 'TOP_TEN',
  VALIDATION = 'VALIDATION'
}

export enum ReviewSection {
  ACCOUNTING = 'ACCOUNTING',
  ALL = 'ALL',
  CAMPAIGN_CARD = 'CAMPAIGN_CARD'
}

export type RiskItemInput = {
  explanation?: InputMaybe<Scalars['String']>;
  state: RiskItemState;
};

export enum RiskItemState {
  CHECKED = 'CHECKED',
  NONE = 'NONE',
  RISK_FOUND = 'RISK_FOUND',
  RISK_HANDLED = 'RISK_HANDLED'
}

export type SearchPageOfUsersInput = {
  order?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  searchString: Scalars['String'];
};

export type SetFilePublishingStatusInput = {
  emissionProcessId: Scalars['String'];
  id: Scalars['String'];
  isPublished: Scalars['Boolean'];
};

export type ShareholderInput = {
  email: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  shares: Scalars['Float'];
};

export type SignRiskEvaluationInput = {
  calculatedRisk: EvaluatedRisk;
  reasoning?: InputMaybe<Scalars['String']>;
  risk: EvaluatedRisk;
};

export enum SignatureDocumentPurposeEnum {
  CUSTOMER_AGREEMENT = 'CUSTOMER_AGREEMENT',
  DECLARATION_OF_COMPLETENESS = 'DECLARATION_OF_COMPLETENESS'
}

export enum SignedEmissionActivity {
  ISSUER_OPENED = 'ISSUER_OPENED'
}

export type SignedEmissionListFilters = {
  activities: Array<SignedEmissionActivity>;
  facilitators: Array<Scalars['String']>;
};

export enum SigneeIdentifier {
  EMAIL = 'EMAIL',
  ID = 'ID',
  SSN = 'SSN'
}

export type SigneeInput = {
  organizationNumber?: InputMaybe<Scalars['String']>;
  type: SigneeType;
  vpsAccount?: InputMaybe<Scalars['String']>;
};

export enum SigneeSignatureStatus {
  NONE = 'NONE',
  READ = 'READ',
  SIGNED = 'SIGNED'
}

export enum SigneeType {
  BUSINESS = 'BUSINESS',
  PERSON = 'PERSON'
}

export enum SigningProcessStatus {
  CANCELLED = 'CANCELLED',
  CREATED = 'CREATED',
  EXPIRED = 'EXPIRED',
  NONE = 'NONE',
  PACKAGED = 'PACKAGED',
  PARTIALLY_SIGNED = 'PARTIALLY_SIGNED',
  SIGNED = 'SIGNED'
}

export type SortingInput = {
  sortBy?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
};

export type SpvBankInformationInput = {
  spvBankAccountNumber?: InputMaybe<Scalars['String']>;
  spvBankDocumentation: Array<IoInfoDocumentInput>;
  spvBankIbanNumber?: InputMaybe<Scalars['String']>;
  spvBankSwiftNumber?: InputMaybe<Scalars['String']>;
};

export type SpvCompanyInformationInput = {
  spvCompanyName?: InputMaybe<Scalars['String']>;
  spvOrganizationNumber?: InputMaybe<Scalars['String']>;
};

export type StriseInputs = {
  bankruptcyCheck?: InputMaybe<RiskItemInput>;
  ceoAndBoard?: InputMaybe<RiskItemInput>;
  kyc?: InputMaybe<RiskItemInput>;
  lastEventsCapitalSeeker?: InputMaybe<RiskItemInput>;
  paymentMarkings?: InputMaybe<RiskItemInput>;
  relatedCompanies?: InputMaybe<RiskItemInput>;
};

export enum TeamAndNetworkEmploymentType {
  CONTRACTOR = 'CONTRACTOR',
  FULL_TIME = 'FULL_TIME',
  PART_TIME = 'PART_TIME'
}

export type TeamAndNetworkMemberInput = {
  bio?: InputMaybe<Scalars['String']>;
  employment?: InputMaybe<TeamAndNetworkEmploymentType>;
  facebook?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  linkedin?: InputMaybe<Scalars['String']>;
  memberPicture?: InputMaybe<CroppedImageInput>;
  name?: InputMaybe<Scalars['String']>;
  ownership?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
  twitter?: InputMaybe<Scalars['String']>;
};

export enum UnsignedEmissionActivity {
  CONTRACT_APPLICATION = 'CONTRACT_APPLICATION',
  CONTRACT_APPLICATION_SUBMITTED = 'CONTRACT_APPLICATION_SUBMITTED',
  INFO_MEETING = 'INFO_MEETING',
  MANDATE = 'MANDATE',
  MANDATE_APPROVED = 'MANDATE_APPROVED',
  REGISTRATION_FORM = 'REGISTRATION_FORM',
  RISK_EVALUATION = 'RISK_EVALUATION'
}

export type UpdateAccountingInput = {
  accountingFirm?: InputMaybe<AccountingFirmInput>;
  annualAccounts?: InputMaybe<Array<IoInfoDocumentInput>>;
  annualAccountsPreviousYears?: InputMaybe<Array<IoInfoDocumentInput>>;
  auditReports?: InputMaybe<Array<IoInfoDocumentInput>>;
  auditor?: InputMaybe<AuditorInput>;
  budgetPrognosis?: InputMaybe<IoInfoDocumentInput>;
  captable?: InputMaybe<IoInfoDocumentInput>;
  captableExplanation?: InputMaybe<Scalars['String']>;
  companyHasNationalProspectus?: InputMaybe<Scalars['Boolean']>;
  companyHasPreviousValuations?: InputMaybe<Scalars['Boolean']>;
  companyHasShareholderAgreement?: InputMaybe<Scalars['Boolean']>;
  companyIsNotSubjectToAuditing?: InputMaybe<Scalars['Boolean']>;
  hasCompanyAuditor?: InputMaybe<Scalars['Boolean']>;
  isCompanySubjectToAudit?: InputMaybe<Scalars['Boolean']>;
  legalMatters?: InputMaybe<Array<IoInfoDocumentInput>>;
  legalMattersExplanation?: InputMaybe<Scalars['String']>;
  legalMattersHasCriminalBackground?: InputMaybe<Scalars['Boolean']>;
  missionCriticalAgreements?: InputMaybe<Array<MissionCriticalAgreementInput>>;
  nationalProspectus?: InputMaybe<IoInfoDocumentInput>;
  nationalProspectusExplanation?: InputMaybe<Scalars['String']>;
  otherObligations?: InputMaybe<Array<IoInfoDocumentInput>>;
  otherObligationsExplanation?: InputMaybe<Scalars['String']>;
  previousBidsOrSalesOfCompany?: InputMaybe<Scalars['Boolean']>;
  previousSalesProcesses?: InputMaybe<IoInfoDocumentInput>;
  previousSalesProcessesExplanation?: InputMaybe<Scalars['String']>;
  previousTransactionProcesses?: InputMaybe<IoInfoDocumentInput>;
  previousTransactionProcessesExplanation?: InputMaybe<Scalars['String']>;
  previousTransactionsRelatedToTradingOtherCompanies?: InputMaybe<Scalars['Boolean']>;
  previousValuations?: InputMaybe<Array<IoInfoDocumentInput>>;
  previousValuationsExplanations?: InputMaybe<Scalars['String']>;
  reconciledAccountBalanceReport?: InputMaybe<Array<IoInfoDocumentInput>>;
  reconciledAccountProfitReport?: InputMaybe<Array<IoInfoDocumentInput>>;
  shareholderAgreement?: InputMaybe<Array<IoInfoDocumentInput>>;
  valuationDocument?: InputMaybe<IoInfoDocumentInput>;
  valuationDocumentExplanation?: InputMaybe<Scalars['String']>;
};

export type UpdateBeneficialOwnerInput = {
  id: Scalars['ID'];
  noMLOrTerrorismFinancing?: InputMaybe<Scalars['Boolean']>;
  shareInPts?: InputMaybe<Scalars['Float']>;
};

export type UpdateCampaignCardInput = {
  campaignCardImage?: InputMaybe<CroppedImageInput>;
  caption?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export type UpdateCompanyDataInput = {
  address?: InputMaybe<Scalars['String']>;
  ceoName?: InputMaybe<Scalars['String']>;
  chairmanName?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  contactPerson?: InputMaybe<ContactPersonInput>;
  equity?: InputMaybe<Scalars['Float']>;
  estimatedCompanyValue?: InputMaybe<Scalars['Float']>;
  foundingDate?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
  industryCode?: InputMaybe<Scalars['String']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']>;
  numberOfShares?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  publicAnnualAccounts?: InputMaybe<Scalars['String']>;
  sectorCode?: InputMaybe<Scalars['String']>;
};

export type UpdateEmissionAgreementsInput = {
  description?: InputMaybe<Scalars['String']>;
  documentation?: InputMaybe<IoInfoDocumentInput>;
  numberOfShares?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateEmissionBankingInfo = {
  bankAccountNumber?: InputMaybe<Scalars['String']>;
  bankIbanNumber?: InputMaybe<Scalars['String']>;
  bankSwiftNumber?: InputMaybe<Scalars['String']>;
  documentation?: InputMaybe<IoInfoDocumentInput>;
};

export type UpdateEmissionCompanyValuation = {
  numberOfShares?: InputMaybe<Scalars['Int']>;
  shareCapital?: InputMaybe<Scalars['SafeInt']>;
  subscriptionPricePerShare?: InputMaybe<Scalars['Int']>;
};

export type UpdateEmissionCoreCompetencies = {
  board?: InputMaybe<Scalars['Boolean']>;
  employees?: InputMaybe<Scalars['Boolean']>;
  founders?: InputMaybe<Scalars['Boolean']>;
  hiredConsultants?: InputMaybe<Scalars['Boolean']>;
  hiring?: InputMaybe<Scalars['Boolean']>;
  notCovered?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateEmissionCoreCompetencyPossession = {
  coreCompetencies?: InputMaybe<UpdateEmissionCoreCompetencies>;
  description?: InputMaybe<Scalars['String']>;
};

export type UpdateEmissionDocumentsInput = {
  additionalDocuments: Array<IoInfoAdditionalDocumentInput>;
};

export type UpdateEmissionEquity = {
  description?: InputMaybe<Scalars['String']>;
  hasEnoughAssetsToCoverDebt?: InputMaybe<Scalars['Boolean']>;
  hasPositiveEquity?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateEmissionExpectedPositiveOperatingResult = {
  description?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<ExpectedPositiveOperatingResultEnum>;
};

export type UpdateEmissionFundraisingTarget = {
  targetAmount?: InputMaybe<Scalars['SafeInt']>;
};

export type UpdateEmissionFurtherFinancing = {
  description?: InputMaybe<Scalars['String']>;
  plansForFutureEmissions?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateEmissionIncubatorOrAccelerator = {
  list?: InputMaybe<Array<InputMaybe<UpdateIncubatorOrAccelerator>>>;
  notParticipated?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateEmissionInformationInput = {
  bankingInfo?: InputMaybe<UpdateEmissionBankingInfo>;
  companyCertificateDocument?: InputMaybe<IoInfoDocumentInput>;
  companyValuation?: InputMaybe<UpdateEmissionCompanyValuation>;
  coreCompetencyPossession?: InputMaybe<UpdateEmissionCoreCompetencyPossession>;
  customerGroup?: InputMaybe<Scalars['String']>;
  equity?: InputMaybe<UpdateEmissionEquity>;
  expectedPositiveOperatingResult?: InputMaybe<UpdateEmissionExpectedPositiveOperatingResult>;
  foundingDocument?: InputMaybe<IoInfoDocumentInput>;
  fundraisingTarget?: InputMaybe<UpdateEmissionFundraisingTarget>;
  furtherFinancing?: InputMaybe<UpdateEmissionFurtherFinancing>;
  incubatorOrAccelerator?: InputMaybe<UpdateEmissionIncubatorOrAccelerator>;
  investmentLimits?: InputMaybe<UpdateEmissionInvestmentLimits>;
  liquidity?: InputMaybe<UpdateEmissionLiquidity>;
  loanFromShareholders?: InputMaybe<UpdateEmissionLoanFromShareholders>;
  loans?: InputMaybe<UpdateEmissionLoans>;
  market?: InputMaybe<UpdateEmissionMarket>;
  nationalDevelopmentBankLoan?: InputMaybe<UpdateEmissionNationalDevelopmentBankLoan>;
  numberOfEmployees?: InputMaybe<UpdateEmissionNumberOfEmployees>;
  numberOfManYears?: InputMaybe<UpdateEmissionNumberOfManYears>;
  options?: InputMaybe<UpdateEmissionOptions>;
  paidUpCapital?: InputMaybe<Array<InputMaybe<UpdateEmissionPaidUpCapital>>>;
  partOfCorporation?: InputMaybe<UpdateEmissionPartOfCorporation>;
  paymentRemarks?: InputMaybe<UpdateEmissionPaymentRemarks>;
  previousStartupExperience?: InputMaybe<UpdateEmissionPreviousStartupExperience>;
  runway?: InputMaybe<UpdateEmissionRunway>;
  shareholderInformationManagement?: InputMaybe<Scalars['String']>;
  sharesToIssue?: InputMaybe<UpdateEmissionSharesToIssue>;
  softFunding?: InputMaybe<UpdateEmissionSoftFunding>;
  statutesChanges?: InputMaybe<UpdateEmissionStatutesChanges>;
  statutesDocument?: InputMaybe<IoInfoDocumentInput>;
  taxIncentiveScheme?: InputMaybe<UpdateEmissionTaxIncentiveScheme>;
};

export type UpdateEmissionInvestmentLimits = {
  maxInvestmentInSharesPerInvestor?: InputMaybe<Scalars['Int']>;
  minInvestmentInSharesPerInvestor?: InputMaybe<Scalars['Int']>;
};

export type UpdateEmissionLiquidity = {
  description?: InputMaybe<Scalars['String']>;
  hasCashToCoverCommitmentsOnDueDate?: InputMaybe<Scalars['Boolean']>;
  hasLiquidityToCoverCommitments?: InputMaybe<Scalars['Boolean']>;
  runway?: InputMaybe<EmissionRunwayEnum>;
};

export type UpdateEmissionLoanFromShareholders = {
  agreements?: InputMaybe<Array<InputMaybe<IoInfoDocumentInput>>>;
  description?: InputMaybe<Scalars['String']>;
  hasLoanFromShareholders?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateEmissionLoans = {
  hasOtherLoans?: InputMaybe<Scalars['Boolean']>;
  otherLoans?: InputMaybe<Array<InputMaybe<UpdateEmissionOtherLoanDocumentation>>>;
};

export type UpdateEmissionMarket = {
  description?: InputMaybe<Scalars['String']>;
  marketArea?: InputMaybe<UpdateEmissionMarketArea>;
};

export type UpdateEmissionMarketArea = {
  europe?: InputMaybe<Scalars['Boolean']>;
  global?: InputMaybe<Scalars['Boolean']>;
  norway?: InputMaybe<Scalars['Boolean']>;
  scandinavia?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateEmissionNationalDevelopmentBankLoan = {
  amount?: InputMaybe<Scalars['SafeInt']>;
  description?: InputMaybe<Scalars['String']>;
  documentation?: InputMaybe<IoInfoDocumentInput>;
  noLoanRecieved?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateEmissionNumberOfEmployees = {
  description?: InputMaybe<Scalars['String']>;
  fullTime?: InputMaybe<Scalars['Int']>;
  partTime?: InputMaybe<Scalars['Int']>;
};

export type UpdateEmissionNumberOfManYears = {
  description?: InputMaybe<Scalars['String']>;
  manYears?: InputMaybe<Scalars['Int']>;
};

export type UpdateEmissionOptions = {
  agreements?: InputMaybe<Array<InputMaybe<UpdateEmissionAgreementsInput>>>;
  hasOptions?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateEmissionOtherLoanDocumentation = {
  description?: InputMaybe<Scalars['String']>;
  documentation?: InputMaybe<IoInfoDocumentInput>;
};

export type UpdateEmissionPaidUpCapital = {
  description?: InputMaybe<Scalars['String']>;
  emissionDate?: InputMaybe<Scalars['Date']>;
  paidUpCapitalAmount?: InputMaybe<Scalars['SafeInt']>;
  valuation?: InputMaybe<Scalars['SafeInt']>;
};

export type UpdateEmissionPartOfCorporation = {
  description?: InputMaybe<Scalars['String']>;
  partOfCorporation?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateEmissionPaymentRemarks = {
  description?: InputMaybe<Scalars['String']>;
  hasPaymentRemarks?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateEmissionPreviousStartupExperience = {
  description?: InputMaybe<Scalars['String']>;
  experience?: InputMaybe<UpdateEmissionPreviousStartupExperiences>;
};

export type UpdateEmissionPreviousStartupExperiences = {
  boardHasSold?: InputMaybe<Scalars['Boolean']>;
  hasEstablished?: InputMaybe<Scalars['Boolean']>;
  hasSold?: InputMaybe<Scalars['Boolean']>;
  noExperience?: InputMaybe<Scalars['Boolean']>;
  wentBankrupt?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateEmissionRunway = {
  description?: InputMaybe<Scalars['String']>;
  numberOfMonths?: InputMaybe<Scalars['Int']>;
};

export type UpdateEmissionSharesToIssue = {
  maxSharesToIssue?: InputMaybe<Scalars['Int']>;
  minSharesToIssue?: InputMaybe<Scalars['Int']>;
};

export type UpdateEmissionSoftFunding = {
  hasNotRecievedFunding?: InputMaybe<Scalars['Boolean']>;
  softFundingRounds?: InputMaybe<Array<InputMaybe<UpdateEmissionSoftFundingRounds>>>;
};

export type UpdateEmissionSoftFundingRounds = {
  amount?: InputMaybe<Scalars['SafeInt']>;
  description?: InputMaybe<Scalars['String']>;
  documentation?: InputMaybe<IoInfoDocumentInput>;
  institution?: InputMaybe<EmissionSoftFundingInstitutionsEnum>;
  nameOfInstitution?: InputMaybe<Scalars['String']>;
};

export type UpdateEmissionStatutesChanges = {
  documentation?: InputMaybe<IoInfoDocumentInput>;
  statutesChanges?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateEmissionTaxIncentiveScheme = {
  description?: InputMaybe<Scalars['String']>;
  satisfiesRequirementsForTaxDeduction?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateIncubatorOrAccelerator = {
  description?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  inProgress?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date']>;
};

export type UpdateIoInfoAdditionalDocumentInput = {
  additionalDocuments: Array<IoInfoAdditionalDocumentInput>;
};

export type UpdateIoInformationDocumentPublishingStatusInput = {
  fieldName: Scalars['String'];
  fileId: Scalars['ID'];
  shouldBePublished: Scalars['Boolean'];
};

export type UpdateLeadInfoInput = {
  companyDescription?: InputMaybe<Scalars['String']>;
  companyValuation?: InputMaybe<Scalars['SafeInt']>;
  contactEmail: Scalars['String'];
  contactName: Scalars['String'];
  contactPhone: PhoneNumberInput;
  estimatedTimePeriod?: InputMaybe<EstimatedTimePeriod>;
  fundraisingTarget?: InputMaybe<Scalars['SafeInt']>;
  numberOfShares?: InputMaybe<Scalars['Int']>;
  organization: OptionalOrganizationInput;
  shareCapital?: InputMaybe<Scalars['SafeInt']>;
  token: Scalars['String'];
};

export type UpdateSinglePurposeVehicleInput = {
  spvBankInformation?: InputMaybe<SpvBankInformationInput>;
  spvCompanyInformation?: InputMaybe<SpvCompanyInformationInput>;
  spvFoundingDocument?: InputMaybe<IoInfoDocumentInput>;
  spvLimitValueShareAmount?: InputMaybe<Scalars['SafeInt']>;
  spvNominalShareValue?: InputMaybe<Scalars['SafeInt']>;
  spvOperatingAgreement?: InputMaybe<IoInfoDocumentInput>;
  spvShareholderAgreement?: InputMaybe<IoInfoDocumentInput>;
  spvStatutes?: InputMaybe<IoInfoDocumentInput>;
};

export type UpdateTeamAndNetworkInput = {
  board?: InputMaybe<Array<InputMaybe<TeamAndNetworkMemberInput>>>;
  partners?: InputMaybe<Array<InputMaybe<TeamAndNetworkMemberInput>>>;
  team?: InputMaybe<Array<InputMaybe<TeamAndNetworkMemberInput>>>;
};

export enum WeeklyMarketingEmailGenerationState {
  CREATING_CONTACT_LIST = 'CREATING_CONTACT_LIST',
  CREATING_SENDGRID_SINGLE_SEND_ITEM = 'CREATING_SENDGRID_SINGLE_SEND_ITEM',
  DONE = 'DONE',
  FETCHING_EMISSIONS = 'FETCHING_EMISSIONS',
  GENERATING_HTML = 'GENERATING_HTML',
  GENERATING_ONGOING_CARD_DATA = 'GENERATING_ONGOING_CARD_DATA',
  STARTED = 'STARTED',
  STARTING_JOB_GENERATING_AND_UPLOADING_CONTACTS = 'STARTING_JOB_GENERATING_AND_UPLOADING_CONTACTS'
}

export type GetPublishedCampaignCardsByStateQueryVariables = Exact<{
  state: Array<PublishedCampaignCardState> | PublishedCampaignCardState;
}>;


export type GetPublishedCampaignCardsByStateQuery = { __typename?: 'Query', publishedCampaignCardsByState: Array<{ __typename?: 'PublishedCampaignCard', id: string, title: string, website?: string | null, caption: string, state: PublishedCampaignCardState, image: { __typename?: 'File', id: string, url?: string | null }, publicInvestmentOffer?: { __typename?: 'PublicInvestmentOffer', id: string, emissionProcessId: string, followerCount: number, recentSubscriptionsCount: number, subscriptionsCount: number, recentPageViewsCount: number, finishedSuccessfully?: boolean | null, pricePerShare?: number | null, slug?: string | null, preorderSlug?: string | null, dates?: { __typename?: 'PublicInvestmentOfferDates', publish: string, open: string, close: string } | null } | null }> };

export type GetPublishedCampaignCardDataQueryVariables = Exact<{
  emissionProcessId: Scalars['ID'];
  includePublicInvestmentOffer: Scalars['Boolean'];
}>;


export type GetPublishedCampaignCardDataQuery = { __typename?: 'Query', investmentOfferVisitor: { __typename?: 'InvestmentOfferVisitor', id?: string | null, emissionProcessId: string, isFollowing?: boolean | null, acceptsPreorderOffers?: boolean | null, approvedForPreorder?: boolean | null, isOwner?: boolean | null, isContributor?: boolean | null }, publishedCampaignCardByEmissionProcessId?: { __typename?: 'PublishedCampaignCard', id: string, publicInvestmentOffer?: { __typename?: 'PublicInvestmentOffer', id: string, emissionProcessId: string, maxSharesToIssue: number, minSharesToIssue: number, pricePerShare?: number | null, totalAmountReserved: number, totalSharesReserved: number, subscribersCount: number } | null } | null };

export type InvestmentOfferVisitorFragment = { __typename?: 'InvestmentOfferVisitor', id?: string | null, emissionProcessId: string, isFollowing?: boolean | null, acceptsPreorderOffers?: boolean | null, approvedForPreorder?: boolean | null, isOwner?: boolean | null, isContributor?: boolean | null };

export type FetchCampaignFollowerCountQueryVariables = Exact<{
  emissionProcessId: Scalars['ID'];
}>;


export type FetchCampaignFollowerCountQuery = { __typename?: 'Query', publishedCampaignCardByEmissionProcessId?: { __typename?: 'PublishedCampaignCard', id: string, publicInvestmentOffer?: { __typename?: 'PublicInvestmentOffer', id: string, followerCount: number } | null } | null };

export type InvestmentOfferFollowerInformationQueryVariables = Exact<{
  emissionProcessId: Scalars['ID'];
}>;


export type InvestmentOfferFollowerInformationQuery = { __typename?: 'Query', investmentOfferVisitor: { __typename?: 'InvestmentOfferVisitor', id?: string | null, emissionProcessId: string, isFollowing?: boolean | null, acceptsPreorderOffers?: boolean | null, approvedForPreorder?: boolean | null, isOwner?: boolean | null, isContributor?: boolean | null }, publishedCampaignCardByEmissionProcessId?: { __typename?: 'PublishedCampaignCard', id: string, title: string, website?: string | null, caption: string, state: PublishedCampaignCardState, image: { __typename?: 'File', id: string, url?: string | null }, publicInvestmentOffer?: { __typename?: 'PublicInvestmentOffer', id: string, emissionProcessId: string, followerCount: number, recentSubscriptionsCount: number, subscriptionsCount: number, recentPageViewsCount: number, finishedSuccessfully?: boolean | null, pricePerShare?: number | null, slug?: string | null, preorderSlug?: string | null, dates?: { __typename?: 'PublicInvestmentOfferDates', publish: string, open: string, close: string } | null } | null } | null };

export type FollowInvestmentOfferMutationVariables = Exact<{
  emissionProcessId: Scalars['ID'];
  follower: InvestmentOfferFollowerInput;
}>;


export type FollowInvestmentOfferMutation = { __typename?: 'Mutation', followInvestmentOffer: { __typename?: 'PublicInvestmentOffer', id: string, followerCount: number } };

export type UnfollowInvestmentOfferMutationVariables = Exact<{
  emissionProcessId: Scalars['ID'];
}>;


export type UnfollowInvestmentOfferMutation = { __typename?: 'Mutation', unfollowInvestmentOffer: { __typename?: 'PublicInvestmentOffer', id: string, followerCount: number } };

export type GetNumberOfInvestorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNumberOfInvestorsQuery = { __typename?: 'Query', statisticsPageData?: { __typename?: 'KeyStatisticsValues', investors?: number | null } | null };

export type PublishedCampaignCardFragment = { __typename?: 'PublishedCampaignCard', id: string, title: string, website?: string | null, caption: string, state: PublishedCampaignCardState, image: { __typename?: 'File', id: string, url?: string | null }, publicInvestmentOffer?: { __typename?: 'PublicInvestmentOffer', id: string, emissionProcessId: string, followerCount: number, recentSubscriptionsCount: number, subscriptionsCount: number, recentPageViewsCount: number, finishedSuccessfully?: boolean | null, pricePerShare?: number | null, slug?: string | null, preorderSlug?: string | null, dates?: { __typename?: 'PublicInvestmentOfferDates', publish: string, open: string, close: string } | null } | null };

export type FileDataFragment = { __typename?: 'File', id: string, name: string, url?: string | null, size: number, mimeType: string, createdAt: string };

export type GetPublishedCampaignCardsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPublishedCampaignCardsQuery = { __typename?: 'Query', getPublishedCampaignCards: Array<{ __typename?: 'PublishedCampaignCard', id: string, title: string, website?: string | null, caption: string, state: PublishedCampaignCardState, image: { __typename?: 'File', id: string, url?: string | null }, publicInvestmentOffer?: { __typename?: 'PublicInvestmentOffer', id: string, emissionProcessId: string, followerCount: number, recentSubscriptionsCount: number, subscriptionsCount: number, recentPageViewsCount: number, finishedSuccessfully?: boolean | null, pricePerShare?: number | null, slug?: string | null, preorderSlug?: string | null, dates?: { __typename?: 'PublicInvestmentOfferDates', publish: string, open: string, close: string } | null } | null }> };

export type MyReservedSubscriptionFragment = { __typename?: 'ReservedSubscription', id: string, paymentRefId: string, numberOfShares: number, amount: number, tags: Array<ReservedSubscriptionTag>, rejected?: boolean | null, withdrawn?: boolean | null, withdrawnReason?: string | null, cancelled?: boolean | null, cancelledReason?: string | null, paymentInfoReceivedAt: Array<string>, paymentDueDate?: string | null, paymentReceivedAt?: string | null, createdAt: string, bankingInfo?: { __typename?: 'PublicInvestmentOfferBankInformation', name?: PaymentTarget | null, companyName?: string | null, organizationNumber?: string | null, bankAccountNumber?: string | null, bankIbanNumber?: string | null, bankSwiftNumber?: string | null } | null, signee: { __typename?: 'SigneeBusiness', type: SigneeType, name: string, email: string, vpsAccount?: string | null, address: { __typename?: 'Address', street?: string | null, postalTown?: string | null, countryCode?: string | null, postalCode?: string | null } } | { __typename?: 'SigneePerson', type: SigneeType, name: string, email: string, vpsAccount?: string | null, address: { __typename?: 'Address', street?: string | null, postalTown?: string | null, countryCode?: string | null, postalCode?: string | null } }, publicInvestmentOffer: { __typename?: 'PublicInvestmentOffer', id: string, emissionProcessId: string, companyName: string, companyAddress: string, organizationNumber: string, slug?: string | null, title: string, pricePerShare?: number | null, finishedSuccessfully?: boolean | null, ceoName?: string | null, preorderSlug?: string | null, vpsEnabled?: boolean | null, singlePurposeVehicleEnabled: boolean, dates?: { __typename?: 'PublicInvestmentOfferDates', publish: string, open: string, close: string } | null, singlePurposeVehicle?: { __typename?: 'SinglePurposeVehicleData', spvLimitValueShareAmount?: number | null, spvNominalShareValue?: number | null } | null }, rejection?: { __typename?: 'ReservedSubscriptionRejection', reason: string, processedAt?: string | null } | null };

export type MyReservedSubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyReservedSubscriptionsQuery = { __typename?: 'Query', myReservedSubscriptions: Array<{ __typename?: 'ReservedSubscription', id: string, paymentRefId: string, numberOfShares: number, amount: number, tags: Array<ReservedSubscriptionTag>, rejected?: boolean | null, withdrawn?: boolean | null, withdrawnReason?: string | null, cancelled?: boolean | null, cancelledReason?: string | null, paymentInfoReceivedAt: Array<string>, paymentDueDate?: string | null, paymentReceivedAt?: string | null, createdAt: string, bankingInfo?: { __typename?: 'PublicInvestmentOfferBankInformation', name?: PaymentTarget | null, companyName?: string | null, organizationNumber?: string | null, bankAccountNumber?: string | null, bankIbanNumber?: string | null, bankSwiftNumber?: string | null } | null, signee: { __typename?: 'SigneeBusiness', type: SigneeType, name: string, email: string, vpsAccount?: string | null, address: { __typename?: 'Address', street?: string | null, postalTown?: string | null, countryCode?: string | null, postalCode?: string | null } } | { __typename?: 'SigneePerson', type: SigneeType, name: string, email: string, vpsAccount?: string | null, address: { __typename?: 'Address', street?: string | null, postalTown?: string | null, countryCode?: string | null, postalCode?: string | null } }, publicInvestmentOffer: { __typename?: 'PublicInvestmentOffer', id: string, emissionProcessId: string, companyName: string, companyAddress: string, organizationNumber: string, slug?: string | null, title: string, pricePerShare?: number | null, finishedSuccessfully?: boolean | null, ceoName?: string | null, preorderSlug?: string | null, vpsEnabled?: boolean | null, singlePurposeVehicleEnabled: boolean, dates?: { __typename?: 'PublicInvestmentOfferDates', publish: string, open: string, close: string } | null, singlePurposeVehicle?: { __typename?: 'SinglePurposeVehicleData', spvLimitValueShareAmount?: number | null, spvNominalShareValue?: number | null } | null }, rejection?: { __typename?: 'ReservedSubscriptionRejection', reason: string, processedAt?: string | null } | null }> };

export type WithdrawReservedSubscriptionMutationVariables = Exact<{
  emissionProcessId: Scalars['ID'];
  reservedSubscriptionId: Scalars['ID'];
  reason: Scalars['String'];
}>;


export type WithdrawReservedSubscriptionMutation = { __typename?: 'Mutation', withdrawReservedSubscription: { __typename?: 'ReservedSubscription', id: string, withdrawn?: boolean | null, withdrawnReason?: string | null } };

export type UpdateReservedSubscriptionVpsAccountMutationVariables = Exact<{
  emissionProcessId: Scalars['ID'];
  reservedSubscriptionId: Scalars['ID'];
  vpsAccount: Scalars['String'];
}>;


export type UpdateReservedSubscriptionVpsAccountMutation = { __typename?: 'Mutation', updateReservedSubscriptionVpsAccount: { __typename?: 'ReservedSubscription', id: string, signee: { __typename?: 'SigneeBusiness', vpsAccount?: string | null } | { __typename?: 'SigneePerson', vpsAccount?: string | null } } };

export type GetPublishedCampaignCardByAliasQueryVariables = Exact<{
  alias: Scalars['String'];
}>;


export type GetPublishedCampaignCardByAliasQuery = { __typename?: 'Query', publishedCampaignCardByAlias?: { __typename?: 'PublishedCampaignCard', id: string, title: string, website?: string | null, caption: string, state: PublishedCampaignCardState, image: { __typename?: 'File', id: string, url?: string | null }, publicInvestmentOffer?: { __typename?: 'PublicInvestmentOffer', id: string, emissionProcessId: string, followerCount: number, recentSubscriptionsCount: number, subscriptionsCount: number, recentPageViewsCount: number, finishedSuccessfully?: boolean | null, pricePerShare?: number | null, slug?: string | null, preorderSlug?: string | null, dates?: { __typename?: 'PublicInvestmentOfferDates', publish: string, open: string, close: string } | null } | null } | null };

export type FinishedCampaignCardDataFragment = { __typename?: 'FinishedCampaignCard', id: string, title: string, imageUrl?: string | null, caption: string, website?: string | null, investorCount: number, closeDate: string, wasSuccessful: boolean, maxSharesToIssue: number, minSharesToIssue: number, totalSharesReserved: number, pricePerShare?: number | null };

export type FinishedCampaignCardsQueryVariables = Exact<{
  pagination: PaginationInput;
  filter?: InputMaybe<FinishedCampaignCardsFilterInput>;
}>;


export type FinishedCampaignCardsQuery = { __typename?: 'Query', finishedAndArchivedCampaignCards: { __typename?: 'FinishedAndArchivedCampaignCards', id: string, cards: Array<{ __typename?: 'FinishedCampaignCard', id: string, title: string, imageUrl?: string | null, caption: string, website?: string | null, investorCount: number, closeDate: string, wasSuccessful: boolean, maxSharesToIssue: number, minSharesToIssue: number, totalSharesReserved: number, pricePerShare?: number | null }>, filter?: { __typename?: 'FinishedCampaignCardsFilter', text?: string | null } | null, pagination?: { __typename?: 'Pagination', pageIndex: number, pageSize: number, total: number, hasNext: boolean, hasPrevious: boolean } | null } };

export type GetActiveFrontPageCarouselItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveFrontPageCarouselItemsQuery = { __typename?: 'Query', getActiveFrontPageCarouselItems: Array<{ __typename?: 'ActiveCarouselItem', id: string, tag?: string | null, title?: string | null, subheader?: string | null, content?: string | null, buttonUrl?: string | null, backgroundImageUrl?: string | null, expiresAt?: string | null, animated?: boolean | null, darkThemed?: boolean | null }> };

export type GetKeyStatisticFromIssuerApiQueryVariables = Exact<{ [key: string]: never; }>;


export type GetKeyStatisticFromIssuerApiQuery = { __typename?: 'Query', statisticsPageData?: { __typename?: 'KeyStatisticsValues', raised?: number | null, investors?: number | null, companies?: number | null, fundedCampaigns?: number | null } | null };

export type HasOpenInvestmentOffersQueryVariables = Exact<{ [key: string]: never; }>;


export type HasOpenInvestmentOffersQuery = { __typename?: 'Query', hasOpenInvestmentOffers?: boolean | null };

export type DiscussionThreadDataFragment = { __typename?: 'PublicInvestmentOfferDiscussionThread', id: string, title: string, content: string, byContributor: boolean, byFolkeinvest: boolean, createdAt: string, isSubscribed: boolean, createdBy?: { __typename?: 'PublicUser', id: string, name: string } | null, comments: Array<{ __typename?: 'PublicInvestmentOfferDiscussionComment', id: string, content: string, byContributor: boolean, byFolkeinvest: boolean, createdAt: string, createdBy?: { __typename?: 'PublicUser', id: string, name: string } | null }> };

export type CreateDiscussionThreadMutationVariables = Exact<{
  slug: Scalars['String'];
  input: CreateDiscussionThreadInput;
}>;


export type CreateDiscussionThreadMutation = { __typename?: 'Mutation', createDiscussionThread: { __typename?: 'PublicInvestmentOffer', id: string, emissionProcessId: string, discussions: Array<{ __typename?: 'PublicInvestmentOfferDiscussionThread', id: string, title: string, content: string, byContributor: boolean, byFolkeinvest: boolean, createdAt: string, isSubscribed: boolean, createdBy?: { __typename?: 'PublicUser', id: string, name: string } | null, comments: Array<{ __typename?: 'PublicInvestmentOfferDiscussionComment', id: string, content: string, byContributor: boolean, byFolkeinvest: boolean, createdAt: string, createdBy?: { __typename?: 'PublicUser', id: string, name: string } | null }> }> } };

export type CommentOnDiscussionThreadMutationVariables = Exact<{
  slug: Scalars['String'];
  threadId: Scalars['Int'];
  content: Scalars['String'];
}>;


export type CommentOnDiscussionThreadMutation = { __typename?: 'Mutation', commentOnDiscussionThread: { __typename?: 'PublicInvestmentOffer', id: string, emissionProcessId: string, discussions: Array<{ __typename?: 'PublicInvestmentOfferDiscussionThread', id: string, title: string, content: string, byContributor: boolean, byFolkeinvest: boolean, createdAt: string, isSubscribed: boolean, createdBy?: { __typename?: 'PublicUser', id: string, name: string } | null, comments: Array<{ __typename?: 'PublicInvestmentOfferDiscussionComment', id: string, content: string, byContributor: boolean, byFolkeinvest: boolean, createdAt: string, createdBy?: { __typename?: 'PublicUser', id: string, name: string } | null }> }> } };

export type SetDiscussionThreadSubscriptionStatusMutationVariables = Exact<{
  slug: Scalars['String'];
  threadId: Scalars['Int'];
  subscribed: Scalars['Boolean'];
}>;


export type SetDiscussionThreadSubscriptionStatusMutation = { __typename?: 'Mutation', setDiscussionThreadSubscriptionStatus: { __typename?: 'PublicInvestmentOfferDiscussionThread', id: string, isSubscribed: boolean } };

export type IoInfoDocumentFragment = { __typename?: 'IoInfoDocument', shouldBePublished: boolean, file: { __typename?: 'File', id: string, name: string, url?: string | null, size: number, mimeType: string, createdAt: string } };

export type CompanyInfoDataFragment = { __typename?: 'EmissionCompanyInfoData', customerGroup?: string | null, incubatorOrAccelerator?: { __typename?: 'IncubatorOrAccelerator', notParticipated?: boolean | null, list?: Array<{ __typename?: 'EmissionIncubatorOrAccelerator', name?: string | null, startDate?: string | null, endDate?: string | null, inProgress?: boolean | null, description?: string | null } | null> | null } | null, coreCompetencyPossession?: { __typename?: 'EmissionCoreCompetencyPossession', description?: string | null, coreCompetencies?: { __typename?: 'EmissionCoreCompetencies', founders?: boolean | null, board?: boolean | null, employees?: boolean | null, hiredConsultants?: boolean | null, notCovered?: boolean | null, hiring?: boolean | null } | null } | null, market?: { __typename?: 'EmissionMarket', description?: string | null, marketArea?: { __typename?: 'EmissionMarketArea', norway?: boolean | null, scandinavia?: boolean | null, europe?: boolean | null, global?: boolean | null } | null } | null, previousStartupExperience?: { __typename?: 'EmissionPreviousStartupExperience', description?: string | null, experience?: { __typename?: 'EmissionPreviousStartupExperiences', hasEstablished?: boolean | null, hasSold?: boolean | null, wentBankrupt?: boolean | null, boardHasSold?: boolean | null, noExperience?: boolean | null } | null } | null, numberOfEmployees?: { __typename?: 'EmissionNumberOfEmployees', fullTime?: number | null, partTime?: number | null, description?: string | null } | null, numberOfManYears?: { __typename?: 'EmissionNumberOfManYears', manYears?: number | null, description?: string | null } | null, partOfCorporation?: { __typename?: 'EmissionPartOfCorporation', partOfCorporation?: boolean | null, description?: string | null } | null };

export type EquityOfferingDataFragment = { __typename?: 'EmissionEquityOfferingData', shareholderInformationManagement?: string | null, companyValuation?: { __typename?: 'EmissionCompanyValuation', numberOfShares?: number | null, shareCapital?: number | null, subscriptionPricePerShare?: number | null } | null, fundraisingTarget?: { __typename?: 'EmissionFundraisingTarget', targetAmount?: number | null } | null, sharesToIssue?: { __typename?: 'EmissionSharesToIssue', minSharesToIssue?: number | null, maxSharesToIssue?: number | null } | null, investmentLimits?: { __typename?: 'EmissionInvestmentLimits', minInvestmentInSharesPerInvestor?: number | null, maxInvestmentInSharesPerInvestor?: number | null } | null, statutesChanges?: { __typename?: 'EmissionStatutesChanges', statutesChanges?: boolean | null, documentation?: { __typename?: 'IoInfoDocument', shouldBePublished: boolean, file: { __typename?: 'File', id: string, name: string, url?: string | null, size: number, mimeType: string, createdAt: string } } | null } | null, runway?: { __typename?: 'EmissionRunway', numberOfMonths?: number | null, description?: string | null } | null, furtherFinancing?: { __typename?: 'EmissionFurtherFinancing', plansForFutureEmissions?: boolean | null, description?: string | null } | null };

export type FinancialInfoDataFragment = { __typename?: 'EmissionFinancialInfoData', softFunding?: { __typename?: 'EmissionSoftFunding', hasNotRecievedFunding?: boolean | null, softFundingRounds?: Array<{ __typename?: 'EmissionSoftFundingRounds', amount?: number | null, institution?: EmissionSoftFundingInstitutionsEnum | null, description?: string | null, nameOfInstitution?: string | null, documentation?: { __typename?: 'IoInfoDocument', shouldBePublished: boolean, file: { __typename?: 'File', id: string, name: string, url?: string | null, size: number, mimeType: string, createdAt: string } } | null }> | null } | null, nationalDevelopmentBankLoan?: { __typename?: 'EmissionNationalDevelopmentBankLoan', noLoanRecieved?: boolean | null, amount?: number | null, description?: string | null, documentation?: { __typename?: 'IoInfoDocument', shouldBePublished: boolean, file: { __typename?: 'File', id: string, name: string, url?: string | null, size: number, mimeType: string, createdAt: string } } | null } | null, loanFromShareholders?: { __typename?: 'EmissionLoanFromShareholders', hasLoanFromShareholders?: boolean | null, description?: string | null, agreements?: Array<{ __typename?: 'IoInfoDocument', shouldBePublished: boolean, file: { __typename?: 'File', id: string, name: string, url?: string | null, size: number, mimeType: string, createdAt: string } } | null> | null } | null, loans?: { __typename?: 'EmissionLoans', hasOtherLoans?: boolean | null, otherLoans?: Array<{ __typename?: 'EmissionOtherLoanDocumentation', description?: string | null, documentation?: { __typename?: 'IoInfoDocument', shouldBePublished: boolean, file: { __typename?: 'File', id: string, name: string, url?: string | null, size: number, mimeType: string, createdAt: string } } | null } | null> | null } | null, options?: { __typename?: 'EmissionOptions', hasOptions?: boolean | null, agreements?: Array<{ __typename?: 'EmissionAgreements', numberOfShares?: number | null, title?: string | null, description?: string | null, documentation?: { __typename?: 'IoInfoDocument', shouldBePublished: boolean, file: { __typename?: 'File', id: string, name: string, url?: string | null, size: number, mimeType: string, createdAt: string } } | null } | null> | null } | null, paidUpCapital?: Array<{ __typename?: 'EmissionPaidUpCapital', paidUpCapitalAmount?: number | null, valuation?: number | null, emissionDate?: string | null, description?: string | null }> | null, equity?: { __typename?: 'EmissionEquity', hasPositiveEquity?: boolean | null, hasEnoughAssetsToCoverDebt?: boolean | null, description?: string | null } | null, paymentRemarks?: { __typename?: 'EmissionPaymentRemarks', hasPaymentRemarks?: boolean | null, description?: string | null } | null, liquidity?: { __typename?: 'EmissionLiquidity', hasLiquidityToCoverCommitments?: boolean | null, hasCashToCoverCommitmentsOnDueDate?: boolean | null, runway?: EmissionRunwayEnum | null, description?: string | null } | null, expectedPositiveOperatingResult?: { __typename?: 'EmissionExpectedPositiveOperatingResult', result?: ExpectedPositiveOperatingResultEnum | null, description?: string | null } | null, taxIncentiveScheme?: { __typename?: 'EmissionTaxIncentiveScheme', satisfiesRequirementsForTaxDeduction?: boolean | null, description?: string | null } | null };

export type InvestmentOfferVideoDataFragment = { __typename?: 'InvestmentOfferVideo', id: string, html?: string | null, file: { __typename?: 'File', id: string, name: string, url?: string | null, size: number, mimeType: string, createdAt: string } };

export type PublicPresentationDataFragment = { __typename?: 'PublicInvestmentOfferPresentation', video?: { __typename?: 'InvestmentOfferVideo', id: string, html?: string | null, file: { __typename?: 'File', id: string, name: string, url?: string | null, size: number, mimeType: string, createdAt: string } } | null, coverImage?: { __typename?: 'CroppedImage', cropped: { __typename?: 'File', id: string, name: string, url?: string | null, size: number, mimeType: string, createdAt: string } } | null, fields: Array<{ __typename?: 'PublicInvestmentOfferPresentationField', key: string, data: string, isCustomField: boolean, label?: string | null }> };

export type InvestmentOfferDocumentFragment = { __typename?: 'PublishedInvestmentOfferDocument', title?: string | null, index?: number | null, key: string, primaryDocument: boolean, file: { __typename?: 'File', id: string, name: string, url?: string | null, size: number, mimeType: string, createdAt: string } };

export type TeamAndNetworkMemberFragment = { __typename?: 'TeamAndNetworkMember', id: string, name?: string | null, bio?: string | null, ownership?: number | null, employment?: TeamAndNetworkEmploymentType | null, facebook?: string | null, linkedin?: string | null, title?: string | null, twitter?: string | null, memberPicture?: { __typename?: 'CroppedImage', cropped: { __typename?: 'File', id: string, name: string, url?: string | null, size: number, mimeType: string, createdAt: string } } | null };

export type PublicShareholderFragment = { __typename?: 'PublicShareholder', id: string, name: string, shares: number };

export type SinglePurposeVehicleDataFragment = { __typename?: 'SinglePurposeVehicleData', spvLimitValueShareAmount?: number | null, spvCompanyInformation?: { __typename?: 'SpvCompanyInformation', spvCompanyName?: string | null, spvOrganizationNumber?: string | null } | null, spvOperatingAgreement?: { __typename?: 'IoInfoDocument', shouldBePublished: boolean, file: { __typename?: 'File', id: string, name: string, url?: string | null, size: number, mimeType: string, createdAt: string } } | null, spvShareholderAgreement?: { __typename?: 'IoInfoDocument', shouldBePublished: boolean, file: { __typename?: 'File', id: string, name: string, url?: string | null, size: number, mimeType: string, createdAt: string } } | null, spvStatutes?: { __typename?: 'IoInfoDocument', shouldBePublished: boolean, file: { __typename?: 'File', id: string, name: string, url?: string | null, size: number, mimeType: string, createdAt: string } } | null };

export type PublicInvestmentOfferBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
  queryString?: InputMaybe<Scalars['String']>;
  includeEmission?: InputMaybe<Scalars['Boolean']>;
  includeDiscussion?: InputMaybe<Scalars['Boolean']>;
  includeTeamAndOwners?: InputMaybe<Scalars['Boolean']>;
  includeDocuments?: InputMaybe<Scalars['Boolean']>;
  isPreview?: InputMaybe<Scalars['Boolean']>;
}>;


export type PublicInvestmentOfferBySlugQuery = { __typename?: 'Query', publishedCampaignCardByAlias?: { __typename?: 'PublishedCampaignCard', id: string, caption: string } | null, publicInvestmentOfferBySlug: { __typename?: 'PublicInvestmentOffer', id: string, title: string, slug?: string | null, emissionProcessId: string, maxSharesToIssue: number, minSharesToIssue: number, totalNumberOfShares: number, maxSharesPerInvestor: number, minSharesPerInvestor: number, pricePerShare?: number | null, loanConversionSum: number, companyAddress: string, companyName: string, organizationNumber: string, vpsEnabled?: boolean | null, website?: string | null, singlePurposeVehicleEnabled: boolean, isInValidationPhase: boolean, isPreview: boolean, isReadonly: boolean, emission: { __typename?: 'PublicInvestmentOfferEmissionData', equityOffering: { __typename?: 'EmissionEquityOfferingData', shareholderInformationManagement?: string | null, investmentLimits?: { __typename?: 'EmissionInvestmentLimits', minInvestmentInSharesPerInvestor?: number | null, maxInvestmentInSharesPerInvestor?: number | null } | null, companyValuation?: { __typename?: 'EmissionCompanyValuation', numberOfShares?: number | null, shareCapital?: number | null, subscriptionPricePerShare?: number | null } | null, fundraisingTarget?: { __typename?: 'EmissionFundraisingTarget', targetAmount?: number | null } | null, sharesToIssue?: { __typename?: 'EmissionSharesToIssue', minSharesToIssue?: number | null, maxSharesToIssue?: number | null } | null, statutesChanges?: { __typename?: 'EmissionStatutesChanges', statutesChanges?: boolean | null, documentation?: { __typename?: 'IoInfoDocument', shouldBePublished: boolean, file: { __typename?: 'File', id: string, name: string, url?: string | null, size: number, mimeType: string, createdAt: string } } | null } | null, runway?: { __typename?: 'EmissionRunway', numberOfMonths?: number | null, description?: string | null } | null, furtherFinancing?: { __typename?: 'EmissionFurtherFinancing', plansForFutureEmissions?: boolean | null, description?: string | null } | null }, companyInfo: { __typename?: 'EmissionCompanyInfoData', customerGroup?: string | null, incubatorOrAccelerator?: { __typename?: 'IncubatorOrAccelerator', notParticipated?: boolean | null, list?: Array<{ __typename?: 'EmissionIncubatorOrAccelerator', name?: string | null, startDate?: string | null, endDate?: string | null, inProgress?: boolean | null, description?: string | null } | null> | null } | null, coreCompetencyPossession?: { __typename?: 'EmissionCoreCompetencyPossession', description?: string | null, coreCompetencies?: { __typename?: 'EmissionCoreCompetencies', founders?: boolean | null, board?: boolean | null, employees?: boolean | null, hiredConsultants?: boolean | null, notCovered?: boolean | null, hiring?: boolean | null } | null } | null, market?: { __typename?: 'EmissionMarket', description?: string | null, marketArea?: { __typename?: 'EmissionMarketArea', norway?: boolean | null, scandinavia?: boolean | null, europe?: boolean | null, global?: boolean | null } | null } | null, previousStartupExperience?: { __typename?: 'EmissionPreviousStartupExperience', description?: string | null, experience?: { __typename?: 'EmissionPreviousStartupExperiences', hasEstablished?: boolean | null, hasSold?: boolean | null, wentBankrupt?: boolean | null, boardHasSold?: boolean | null, noExperience?: boolean | null } | null } | null, numberOfEmployees?: { __typename?: 'EmissionNumberOfEmployees', fullTime?: number | null, partTime?: number | null, description?: string | null } | null, numberOfManYears?: { __typename?: 'EmissionNumberOfManYears', manYears?: number | null, description?: string | null } | null, partOfCorporation?: { __typename?: 'EmissionPartOfCorporation', partOfCorporation?: boolean | null, description?: string | null } | null }, financialInfo: { __typename?: 'EmissionFinancialInfoData', softFunding?: { __typename?: 'EmissionSoftFunding', hasNotRecievedFunding?: boolean | null, softFundingRounds?: Array<{ __typename?: 'EmissionSoftFundingRounds', amount?: number | null, institution?: EmissionSoftFundingInstitutionsEnum | null, description?: string | null, nameOfInstitution?: string | null, documentation?: { __typename?: 'IoInfoDocument', shouldBePublished: boolean, file: { __typename?: 'File', id: string, name: string, url?: string | null, size: number, mimeType: string, createdAt: string } } | null }> | null } | null, nationalDevelopmentBankLoan?: { __typename?: 'EmissionNationalDevelopmentBankLoan', noLoanRecieved?: boolean | null, amount?: number | null, description?: string | null, documentation?: { __typename?: 'IoInfoDocument', shouldBePublished: boolean, file: { __typename?: 'File', id: string, name: string, url?: string | null, size: number, mimeType: string, createdAt: string } } | null } | null, loanFromShareholders?: { __typename?: 'EmissionLoanFromShareholders', hasLoanFromShareholders?: boolean | null, description?: string | null, agreements?: Array<{ __typename?: 'IoInfoDocument', shouldBePublished: boolean, file: { __typename?: 'File', id: string, name: string, url?: string | null, size: number, mimeType: string, createdAt: string } } | null> | null } | null, loans?: { __typename?: 'EmissionLoans', hasOtherLoans?: boolean | null, otherLoans?: Array<{ __typename?: 'EmissionOtherLoanDocumentation', description?: string | null, documentation?: { __typename?: 'IoInfoDocument', shouldBePublished: boolean, file: { __typename?: 'File', id: string, name: string, url?: string | null, size: number, mimeType: string, createdAt: string } } | null } | null> | null } | null, options?: { __typename?: 'EmissionOptions', hasOptions?: boolean | null, agreements?: Array<{ __typename?: 'EmissionAgreements', numberOfShares?: number | null, title?: string | null, description?: string | null, documentation?: { __typename?: 'IoInfoDocument', shouldBePublished: boolean, file: { __typename?: 'File', id: string, name: string, url?: string | null, size: number, mimeType: string, createdAt: string } } | null } | null> | null } | null, paidUpCapital?: Array<{ __typename?: 'EmissionPaidUpCapital', paidUpCapitalAmount?: number | null, valuation?: number | null, emissionDate?: string | null, description?: string | null }> | null, equity?: { __typename?: 'EmissionEquity', hasPositiveEquity?: boolean | null, hasEnoughAssetsToCoverDebt?: boolean | null, description?: string | null } | null, paymentRemarks?: { __typename?: 'EmissionPaymentRemarks', hasPaymentRemarks?: boolean | null, description?: string | null } | null, liquidity?: { __typename?: 'EmissionLiquidity', hasLiquidityToCoverCommitments?: boolean | null, hasCashToCoverCommitmentsOnDueDate?: boolean | null, runway?: EmissionRunwayEnum | null, description?: string | null } | null, expectedPositiveOperatingResult?: { __typename?: 'EmissionExpectedPositiveOperatingResult', result?: ExpectedPositiveOperatingResultEnum | null, description?: string | null } | null, taxIncentiveScheme?: { __typename?: 'EmissionTaxIncentiveScheme', satisfiesRequirementsForTaxDeduction?: boolean | null, description?: string | null } | null } }, presentation: { __typename?: 'PublicInvestmentOfferPresentation', video?: { __typename?: 'InvestmentOfferVideo', id: string, html?: string | null, file: { __typename?: 'File', id: string, name: string, url?: string | null, size: number, mimeType: string, createdAt: string } } | null, coverImage?: { __typename?: 'CroppedImage', cropped: { __typename?: 'File', id: string, name: string, url?: string | null, size: number, mimeType: string, createdAt: string } } | null, fields: Array<{ __typename?: 'PublicInvestmentOfferPresentationField', key: string, data: string, isCustomField: boolean, label?: string | null }> }, dates?: { __typename?: 'PublicInvestmentOfferDates', publish: string, open: string, close: string } | null, singlePurposeVehicle?: { __typename?: 'SinglePurposeVehicleData', spvLimitValueShareAmount?: number | null, spvCompanyInformation?: { __typename?: 'SpvCompanyInformation', spvCompanyName?: string | null, spvOrganizationNumber?: string | null } | null, spvOperatingAgreement?: { __typename?: 'IoInfoDocument', shouldBePublished: boolean, file: { __typename?: 'File', id: string, name: string, url?: string | null, size: number, mimeType: string, createdAt: string } } | null, spvShareholderAgreement?: { __typename?: 'IoInfoDocument', shouldBePublished: boolean, file: { __typename?: 'File', id: string, name: string, url?: string | null, size: number, mimeType: string, createdAt: string } } | null, spvStatutes?: { __typename?: 'IoInfoDocument', shouldBePublished: boolean, file: { __typename?: 'File', id: string, name: string, url?: string | null, size: number, mimeType: string, createdAt: string } } | null } | null, discussions?: Array<{ __typename?: 'PublicInvestmentOfferDiscussionThread', id: string, title: string, content: string, byContributor: boolean, byFolkeinvest: boolean, createdAt: string, isSubscribed: boolean, createdBy?: { __typename?: 'PublicUser', id: string, name: string } | null, comments: Array<{ __typename?: 'PublicInvestmentOfferDiscussionComment', id: string, content: string, byContributor: boolean, byFolkeinvest: boolean, createdAt: string, createdBy?: { __typename?: 'PublicUser', id: string, name: string } | null }> }>, teamAndNetwork?: { __typename?: 'PublicInvestmentOfferTeamAndNetworkData', team: Array<{ __typename?: 'TeamAndNetworkMember', id: string, name?: string | null, bio?: string | null, ownership?: number | null, employment?: TeamAndNetworkEmploymentType | null, facebook?: string | null, linkedin?: string | null, title?: string | null, twitter?: string | null, memberPicture?: { __typename?: 'CroppedImage', cropped: { __typename?: 'File', id: string, name: string, url?: string | null, size: number, mimeType: string, createdAt: string } } | null }>, board: Array<{ __typename?: 'TeamAndNetworkMember', id: string, name?: string | null, bio?: string | null, ownership?: number | null, employment?: TeamAndNetworkEmploymentType | null, facebook?: string | null, linkedin?: string | null, title?: string | null, twitter?: string | null, memberPicture?: { __typename?: 'CroppedImage', cropped: { __typename?: 'File', id: string, name: string, url?: string | null, size: number, mimeType: string, createdAt: string } } | null }>, partners: Array<{ __typename?: 'TeamAndNetworkMember', id: string, name?: string | null, bio?: string | null, ownership?: number | null, employment?: TeamAndNetworkEmploymentType | null, facebook?: string | null, linkedin?: string | null, title?: string | null, twitter?: string | null, memberPicture?: { __typename?: 'CroppedImage', cropped: { __typename?: 'File', id: string, name: string, url?: string | null, size: number, mimeType: string, createdAt: string } } | null }> }, shareholders?: Array<{ __typename?: 'PublicShareholder', id: string, name: string, shares: number }>, documents?: Array<{ __typename?: 'PublishedInvestmentOfferDocument', title?: string | null, index?: number | null, key: string, primaryDocument: boolean, file: { __typename?: 'File', id: string, name: string, url?: string | null, size: number, mimeType: string, createdAt: string } } | null> | null }, investmentOfferVisitor?: { __typename?: 'InvestmentOfferVisitor', id?: string | null, emissionProcessId: string, isFollowing?: boolean | null, acceptsPreorderOffers?: boolean | null, approvedForPreorder?: boolean | null, isOwner?: boolean | null, isContributor?: boolean | null } };

export type PublicInvestmentOfferSummaryDataFragment = { __typename?: 'PublicInvestmentOfferSubscriptionsSummary', id: string, subscriptionsCount: number, totalSharesReserved: number, subscribersCount: number };

export type PublicInvestmentOfferSummaryQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type PublicInvestmentOfferSummaryQuery = { __typename?: 'Query', publicInvestmentOfferSummary: { __typename?: 'PublicInvestmentOfferSubscriptionsSummary', id: string, subscriptionsCount: number, totalSharesReserved: number, subscribersCount: number }, mySubscriptionsSummaryBySlug: { __typename?: 'MySubscriptionsSummaryForInvestmentOffer', id: string, mySubscriptionsCount: number, myTotalSharesReserved: number } };

export type PublicInvestmentOfferSummaryChangedSubscriptionVariables = Exact<{
  slug: Scalars['String'];
}>;


export type PublicInvestmentOfferSummaryChangedSubscription = { __typename?: 'Subscription', publicInvestmentOfferSummaryChanged: { __typename?: 'PublicInvestmentOfferSubscriptionsSummary', id: string, subscriptionsCount: number, totalSharesReserved: number, subscribersCount: number } };

export type PublicInvestmentOfferDiscussionChangedSubscriptionVariables = Exact<{
  slug: Scalars['String'];
}>;


export type PublicInvestmentOfferDiscussionChangedSubscription = { __typename?: 'Subscription', publicInvestmentOfferDiscussionChanged: { __typename?: 'PublicInvestmentOffer', id: string, discussions: Array<{ __typename?: 'PublicInvestmentOfferDiscussionThread', id: string, title: string, content: string, byContributor: boolean, byFolkeinvest: boolean, createdAt: string, isSubscribed: boolean, createdBy?: { __typename?: 'PublicUser', id: string, name: string } | null, comments: Array<{ __typename?: 'PublicInvestmentOfferDiscussionComment', id: string, content: string, byContributor: boolean, byFolkeinvest: boolean, createdAt: string, createdBy?: { __typename?: 'PublicUser', id: string, name: string } | null }> }> } };

export type RegisterInvestmentOfferPageviewMutationVariables = Exact<{
  slug: Scalars['String'];
}>;


export type RegisterInvestmentOfferPageviewMutation = { __typename?: 'Mutation', registerInvestmentOfferPageview: boolean };

export type SigneeTotalSharesCountInInvestmentOfferQueryVariables = Exact<{
  slug: Scalars['String'];
  organizationNumber?: InputMaybe<Scalars['String']>;
}>;


export type SigneeTotalSharesCountInInvestmentOfferQuery = { __typename?: 'Query', signeeTotalSharesCountInInvestmentOffer: number };

export type ReserveSubscriptionMutationVariables = Exact<{
  emissionProcessId: Scalars['ID'];
  reservation: ReserveSubscriptionInput;
  signee: SigneeInput;
}>;


export type ReserveSubscriptionMutation = { __typename?: 'Mutation', reserveSubscription: { __typename?: 'ReservedSubscription', id: string } };

export type SendFeedbackMutationVariables = Exact<{
  reservationId: Scalars['ID'];
  score: Scalars['Int'];
  comment?: InputMaybe<Scalars['String']>;
}>;


export type SendFeedbackMutation = { __typename?: 'Mutation', sendFeedback: { __typename?: 'ReservationFeedback', id: string } };

export type PublicReservedSubscriptionsListChangedSubscriptionVariables = Exact<{
  slug: Scalars['String'];
}>;


export type PublicReservedSubscriptionsListChangedSubscription = { __typename?: 'Subscription', publicReservedSubscriptionsListChanged: Array<{ __typename?: 'PublicReservedSubscription', id: string, name?: string | null, shares: number, createdAt: string }> };

export type PublicReservedSubscriptionsQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type PublicReservedSubscriptionsQuery = { __typename?: 'Query', publicReservedSubscriptionsList: Array<{ __typename?: 'PublicReservedSubscription', id: string, name?: string | null, shares: number, createdAt: string }> };

export type InitialLivePageDataForInvestmentOfferQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type InitialLivePageDataForInvestmentOfferQuery = { __typename?: 'Query', publicInvestmentOfferBySlug: { __typename?: 'PublicInvestmentOffer', id: string, maxSharesToIssue: number, minSharesToIssue: number, pricePerShare?: number | null, title: string, totalAmountReserved: number, totalSharesReserved: number, subscribersCount: number, subscriptionsCount: number, dates?: { __typename?: 'PublicInvestmentOfferDates', open: string, close: string } | null } };

export type LivePageDataForInvestmentOfferSubscriptionVariables = Exact<{
  slug: Scalars['String'];
}>;


export type LivePageDataForInvestmentOfferSubscription = { __typename?: 'Subscription', publicInvestmentOfferSummaryChanged: { __typename?: 'PublicInvestmentOfferSubscriptionsSummary', id: string, subscriptionsCount: number, totalSharesReserved: number, subscribersCount: number } };

export type GetStatisticsPageDataFromIssuerApiQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStatisticsPageDataFromIssuerApiQuery = { __typename?: 'Query', statisticsPageData?: { __typename?: 'KeyStatisticsValues', raised?: number | null, campaigns?: number | null, companies?: number | null, investors?: number | null, campaignsThisYear?: number | null, raisedThisYear?: number | null, fundedCampaigns?: number | null } | null };

export type UnfollowInvestmentOfferByEmailLinkMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type UnfollowInvestmentOfferByEmailLinkMutation = { __typename?: 'Mutation', unfollowInvestmentOfferFromEmailLink: boolean };

export type MyEmissionProcessesInNewIssuerQueryVariables = Exact<{ [key: string]: never; }>;


export type MyEmissionProcessesInNewIssuerQuery = { __typename?: 'Query', myEmissionProcesses: Array<{ __typename?: 'EmissionProcess', id: string }> };

export const InvestmentOfferVisitorFragmentDoc = gql`
    fragment InvestmentOfferVisitor on InvestmentOfferVisitor {
  id
  emissionProcessId
  isFollowing
  acceptsPreorderOffers
  approvedForPreorder
  isOwner
  isContributor
}
    `;
export const PublishedCampaignCardFragmentDoc = gql`
    fragment PublishedCampaignCard on PublishedCampaignCard {
  id
  title
  image {
    id
    url
  }
  website
  caption
  publicInvestmentOffer {
    id
    emissionProcessId
    followerCount
    recentSubscriptionsCount
    subscriptionsCount
    recentPageViewsCount
    finishedSuccessfully
    pricePerShare
    slug
    preorderSlug
    dates {
      publish
      open
      close
    }
  }
  state
}
    `;
export const MyReservedSubscriptionFragmentDoc = gql`
    fragment MyReservedSubscription on ReservedSubscription {
  id
  paymentRefId
  numberOfShares
  amount
  tags
  bankingInfo {
    name
    companyName
    organizationNumber
    bankAccountNumber
    bankIbanNumber
    bankSwiftNumber
  }
  signee {
    type
    name
    email
    address {
      street
      postalTown
      countryCode
      postalCode
    }
    vpsAccount
  }
  publicInvestmentOffer {
    id
    emissionProcessId
    companyName
    companyAddress
    organizationNumber
    dates {
      publish
      open
      close
    }
    slug
    title
    pricePerShare
    finishedSuccessfully
    ceoName
    preorderSlug
    vpsEnabled
    singlePurposeVehicleEnabled
    singlePurposeVehicle {
      spvLimitValueShareAmount
      spvNominalShareValue
    }
  }
  rejected
  rejection {
    reason
    processedAt
  }
  withdrawn
  withdrawnReason
  cancelled
  cancelledReason
  paymentInfoReceivedAt
  paymentDueDate
  paymentReceivedAt
  createdAt
}
    `;
export const FinishedCampaignCardDataFragmentDoc = gql`
    fragment FinishedCampaignCardData on FinishedCampaignCard {
  id
  title
  imageUrl
  caption
  website
  investorCount
  closeDate
  wasSuccessful
  maxSharesToIssue
  minSharesToIssue
  totalSharesReserved
  pricePerShare
}
    `;
export const DiscussionThreadDataFragmentDoc = gql`
    fragment DiscussionThreadData on PublicInvestmentOfferDiscussionThread {
  id
  title
  content
  createdBy {
    id
    name
  }
  byContributor
  byFolkeinvest
  comments {
    id
    content
    byContributor
    byFolkeinvest
    createdBy {
      id
      name
    }
    createdAt
  }
  createdAt
  isSubscribed
}
    `;
export const CompanyInfoDataFragmentDoc = gql`
    fragment CompanyInfoData on EmissionCompanyInfoData {
  incubatorOrAccelerator {
    notParticipated
    list {
      name
      startDate
      endDate
      inProgress
      description
    }
  }
  coreCompetencyPossession {
    description
    coreCompetencies {
      founders
      board
      employees
      hiredConsultants
      notCovered
      hiring
    }
  }
  market {
    marketArea {
      norway
      scandinavia
      europe
      global
    }
    description
  }
  customerGroup
  previousStartupExperience {
    experience {
      hasEstablished
      hasSold
      wentBankrupt
      boardHasSold
      noExperience
    }
    description
  }
  numberOfEmployees {
    fullTime
    partTime
    description
  }
  numberOfManYears {
    manYears
    description
  }
  partOfCorporation {
    partOfCorporation
    description
  }
}
    `;
export const FileDataFragmentDoc = gql`
    fragment FileData on File {
  id
  name
  url
  size
  mimeType
  createdAt
}
    `;
export const IoInfoDocumentFragmentDoc = gql`
    fragment IoInfoDocument on IoInfoDocument {
  shouldBePublished
  file {
    ...FileData
  }
}
    ${FileDataFragmentDoc}`;
export const EquityOfferingDataFragmentDoc = gql`
    fragment EquityOfferingData on EmissionEquityOfferingData {
  shareholderInformationManagement
  companyValuation {
    numberOfShares
    shareCapital
    subscriptionPricePerShare
  }
  fundraisingTarget {
    targetAmount
  }
  sharesToIssue {
    minSharesToIssue
    maxSharesToIssue
  }
  investmentLimits {
    minInvestmentInSharesPerInvestor
    maxInvestmentInSharesPerInvestor
  }
  statutesChanges {
    statutesChanges
    documentation {
      ...IoInfoDocument
    }
  }
  runway {
    numberOfMonths
    description
  }
  furtherFinancing {
    plansForFutureEmissions
    description
  }
}
    ${IoInfoDocumentFragmentDoc}`;
export const FinancialInfoDataFragmentDoc = gql`
    fragment FinancialInfoData on EmissionFinancialInfoData {
  softFunding {
    hasNotRecievedFunding
    softFundingRounds {
      amount
      institution
      description
      nameOfInstitution
      documentation {
        ...IoInfoDocument
      }
    }
  }
  nationalDevelopmentBankLoan {
    noLoanRecieved
    amount
    documentation {
      ...IoInfoDocument
    }
    description
  }
  loanFromShareholders {
    hasLoanFromShareholders
    agreements {
      ...IoInfoDocument
    }
    description
  }
  loans {
    hasOtherLoans
    otherLoans {
      documentation {
        ...IoInfoDocument
      }
      description
    }
  }
  options {
    hasOptions
    agreements {
      numberOfShares
      title
      description
      documentation {
        ...IoInfoDocument
      }
    }
  }
  paidUpCapital {
    paidUpCapitalAmount
    valuation
    emissionDate
    description
  }
  equity {
    hasPositiveEquity
    hasEnoughAssetsToCoverDebt
    description
  }
  paymentRemarks {
    hasPaymentRemarks
    description
  }
  liquidity {
    hasLiquidityToCoverCommitments
    hasCashToCoverCommitmentsOnDueDate
    runway
    description
  }
  expectedPositiveOperatingResult {
    result
    description
  }
  taxIncentiveScheme {
    satisfiesRequirementsForTaxDeduction
    description
  }
}
    ${IoInfoDocumentFragmentDoc}`;
export const InvestmentOfferVideoDataFragmentDoc = gql`
    fragment InvestmentOfferVideoData on InvestmentOfferVideo {
  id
  file {
    ...FileData
  }
  html
}
    ${FileDataFragmentDoc}`;
export const PublicPresentationDataFragmentDoc = gql`
    fragment PublicPresentationData on PublicInvestmentOfferPresentation {
  video {
    ...InvestmentOfferVideoData
  }
  coverImage {
    cropped {
      ...FileData
    }
  }
  fields {
    key
    data
    isCustomField
    label
  }
}
    ${InvestmentOfferVideoDataFragmentDoc}
${FileDataFragmentDoc}`;
export const InvestmentOfferDocumentFragmentDoc = gql`
    fragment InvestmentOfferDocument on PublishedInvestmentOfferDocument {
  file {
    ...FileData
  }
  title
  index
  key
  primaryDocument
}
    ${FileDataFragmentDoc}`;
export const TeamAndNetworkMemberFragmentDoc = gql`
    fragment TeamAndNetworkMember on TeamAndNetworkMember {
  id
  name
  bio
  memberPicture {
    cropped {
      ...FileData
    }
  }
  ownership
  employment
  facebook
  linkedin
  ownership
  title
  twitter
}
    ${FileDataFragmentDoc}`;
export const PublicShareholderFragmentDoc = gql`
    fragment PublicShareholder on PublicShareholder {
  id
  name
  shares
}
    `;
export const SinglePurposeVehicleDataFragmentDoc = gql`
    fragment SinglePurposeVehicleData on SinglePurposeVehicleData {
  spvCompanyInformation {
    spvCompanyName
    spvOrganizationNumber
  }
  spvLimitValueShareAmount
  spvOperatingAgreement {
    ...IoInfoDocument
  }
  spvShareholderAgreement {
    ...IoInfoDocument
  }
  spvStatutes {
    ...IoInfoDocument
  }
}
    ${IoInfoDocumentFragmentDoc}`;
export const PublicInvestmentOfferSummaryDataFragmentDoc = gql`
    fragment PublicInvestmentOfferSummaryData on PublicInvestmentOfferSubscriptionsSummary {
  id
  subscriptionsCount
  totalSharesReserved
  subscribersCount
}
    `;
export const GetPublishedCampaignCardsByStateDocument = gql`
    query GetPublishedCampaignCardsByState($state: [PublishedCampaignCardState!]!) {
  publishedCampaignCardsByState(state: $state) {
    ...PublishedCampaignCard
  }
}
    ${PublishedCampaignCardFragmentDoc}`;

/**
 * __useGetPublishedCampaignCardsByStateQuery__
 *
 * To run a query within a React component, call `useGetPublishedCampaignCardsByStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublishedCampaignCardsByStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublishedCampaignCardsByStateQuery({
 *   variables: {
 *      state: // value for 'state'
 *   },
 * });
 */
export function useGetPublishedCampaignCardsByStateQuery(baseOptions: Apollo.QueryHookOptions<GetPublishedCampaignCardsByStateQuery, GetPublishedCampaignCardsByStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublishedCampaignCardsByStateQuery, GetPublishedCampaignCardsByStateQueryVariables>(GetPublishedCampaignCardsByStateDocument, options);
      }
export function useGetPublishedCampaignCardsByStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublishedCampaignCardsByStateQuery, GetPublishedCampaignCardsByStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublishedCampaignCardsByStateQuery, GetPublishedCampaignCardsByStateQueryVariables>(GetPublishedCampaignCardsByStateDocument, options);
        }
export type GetPublishedCampaignCardsByStateQueryHookResult = ReturnType<typeof useGetPublishedCampaignCardsByStateQuery>;
export type GetPublishedCampaignCardsByStateLazyQueryHookResult = ReturnType<typeof useGetPublishedCampaignCardsByStateLazyQuery>;
export type GetPublishedCampaignCardsByStateQueryResult = Apollo.QueryResult<GetPublishedCampaignCardsByStateQuery, GetPublishedCampaignCardsByStateQueryVariables>;
export const GetPublishedCampaignCardDataDocument = gql`
    query GetPublishedCampaignCardData($emissionProcessId: ID!, $includePublicInvestmentOffer: Boolean!) {
  investmentOfferVisitor(emissionProcessId: $emissionProcessId) {
    ...InvestmentOfferVisitor
  }
  publishedCampaignCardByEmissionProcessId(emissionProcessId: $emissionProcessId) {
    id
    publicInvestmentOffer @include(if: $includePublicInvestmentOffer) {
      id
      emissionProcessId
      maxSharesToIssue
      minSharesToIssue
      pricePerShare
      totalAmountReserved
      totalSharesReserved
      subscribersCount
    }
  }
}
    ${InvestmentOfferVisitorFragmentDoc}`;

/**
 * __useGetPublishedCampaignCardDataQuery__
 *
 * To run a query within a React component, call `useGetPublishedCampaignCardDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublishedCampaignCardDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublishedCampaignCardDataQuery({
 *   variables: {
 *      emissionProcessId: // value for 'emissionProcessId'
 *      includePublicInvestmentOffer: // value for 'includePublicInvestmentOffer'
 *   },
 * });
 */
export function useGetPublishedCampaignCardDataQuery(baseOptions: Apollo.QueryHookOptions<GetPublishedCampaignCardDataQuery, GetPublishedCampaignCardDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublishedCampaignCardDataQuery, GetPublishedCampaignCardDataQueryVariables>(GetPublishedCampaignCardDataDocument, options);
      }
export function useGetPublishedCampaignCardDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublishedCampaignCardDataQuery, GetPublishedCampaignCardDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublishedCampaignCardDataQuery, GetPublishedCampaignCardDataQueryVariables>(GetPublishedCampaignCardDataDocument, options);
        }
export type GetPublishedCampaignCardDataQueryHookResult = ReturnType<typeof useGetPublishedCampaignCardDataQuery>;
export type GetPublishedCampaignCardDataLazyQueryHookResult = ReturnType<typeof useGetPublishedCampaignCardDataLazyQuery>;
export type GetPublishedCampaignCardDataQueryResult = Apollo.QueryResult<GetPublishedCampaignCardDataQuery, GetPublishedCampaignCardDataQueryVariables>;
export const FetchCampaignFollowerCountDocument = gql`
    query FetchCampaignFollowerCount($emissionProcessId: ID!) {
  publishedCampaignCardByEmissionProcessId(emissionProcessId: $emissionProcessId) {
    id
    publicInvestmentOffer {
      id
      followerCount
    }
  }
}
    `;

/**
 * __useFetchCampaignFollowerCountQuery__
 *
 * To run a query within a React component, call `useFetchCampaignFollowerCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCampaignFollowerCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCampaignFollowerCountQuery({
 *   variables: {
 *      emissionProcessId: // value for 'emissionProcessId'
 *   },
 * });
 */
export function useFetchCampaignFollowerCountQuery(baseOptions: Apollo.QueryHookOptions<FetchCampaignFollowerCountQuery, FetchCampaignFollowerCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCampaignFollowerCountQuery, FetchCampaignFollowerCountQueryVariables>(FetchCampaignFollowerCountDocument, options);
      }
export function useFetchCampaignFollowerCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCampaignFollowerCountQuery, FetchCampaignFollowerCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCampaignFollowerCountQuery, FetchCampaignFollowerCountQueryVariables>(FetchCampaignFollowerCountDocument, options);
        }
export type FetchCampaignFollowerCountQueryHookResult = ReturnType<typeof useFetchCampaignFollowerCountQuery>;
export type FetchCampaignFollowerCountLazyQueryHookResult = ReturnType<typeof useFetchCampaignFollowerCountLazyQuery>;
export type FetchCampaignFollowerCountQueryResult = Apollo.QueryResult<FetchCampaignFollowerCountQuery, FetchCampaignFollowerCountQueryVariables>;
export const InvestmentOfferFollowerInformationDocument = gql`
    query InvestmentOfferFollowerInformation($emissionProcessId: ID!) {
  investmentOfferVisitor(emissionProcessId: $emissionProcessId) {
    ...InvestmentOfferVisitor
  }
  publishedCampaignCardByEmissionProcessId(emissionProcessId: $emissionProcessId) {
    ...PublishedCampaignCard
  }
}
    ${InvestmentOfferVisitorFragmentDoc}
${PublishedCampaignCardFragmentDoc}`;

/**
 * __useInvestmentOfferFollowerInformationQuery__
 *
 * To run a query within a React component, call `useInvestmentOfferFollowerInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestmentOfferFollowerInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestmentOfferFollowerInformationQuery({
 *   variables: {
 *      emissionProcessId: // value for 'emissionProcessId'
 *   },
 * });
 */
export function useInvestmentOfferFollowerInformationQuery(baseOptions: Apollo.QueryHookOptions<InvestmentOfferFollowerInformationQuery, InvestmentOfferFollowerInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvestmentOfferFollowerInformationQuery, InvestmentOfferFollowerInformationQueryVariables>(InvestmentOfferFollowerInformationDocument, options);
      }
export function useInvestmentOfferFollowerInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvestmentOfferFollowerInformationQuery, InvestmentOfferFollowerInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvestmentOfferFollowerInformationQuery, InvestmentOfferFollowerInformationQueryVariables>(InvestmentOfferFollowerInformationDocument, options);
        }
export type InvestmentOfferFollowerInformationQueryHookResult = ReturnType<typeof useInvestmentOfferFollowerInformationQuery>;
export type InvestmentOfferFollowerInformationLazyQueryHookResult = ReturnType<typeof useInvestmentOfferFollowerInformationLazyQuery>;
export type InvestmentOfferFollowerInformationQueryResult = Apollo.QueryResult<InvestmentOfferFollowerInformationQuery, InvestmentOfferFollowerInformationQueryVariables>;
export const FollowInvestmentOfferDocument = gql`
    mutation FollowInvestmentOffer($emissionProcessId: ID!, $follower: InvestmentOfferFollowerInput!) {
  followInvestmentOffer(
    emissionProcessId: $emissionProcessId
    follower: $follower
  ) {
    id
    followerCount
  }
}
    `;
export type FollowInvestmentOfferMutationFn = Apollo.MutationFunction<FollowInvestmentOfferMutation, FollowInvestmentOfferMutationVariables>;

/**
 * __useFollowInvestmentOfferMutation__
 *
 * To run a mutation, you first call `useFollowInvestmentOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowInvestmentOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followInvestmentOfferMutation, { data, loading, error }] = useFollowInvestmentOfferMutation({
 *   variables: {
 *      emissionProcessId: // value for 'emissionProcessId'
 *      follower: // value for 'follower'
 *   },
 * });
 */
export function useFollowInvestmentOfferMutation(baseOptions?: Apollo.MutationHookOptions<FollowInvestmentOfferMutation, FollowInvestmentOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FollowInvestmentOfferMutation, FollowInvestmentOfferMutationVariables>(FollowInvestmentOfferDocument, options);
      }
export type FollowInvestmentOfferMutationHookResult = ReturnType<typeof useFollowInvestmentOfferMutation>;
export type FollowInvestmentOfferMutationResult = Apollo.MutationResult<FollowInvestmentOfferMutation>;
export type FollowInvestmentOfferMutationOptions = Apollo.BaseMutationOptions<FollowInvestmentOfferMutation, FollowInvestmentOfferMutationVariables>;
export const UnfollowInvestmentOfferDocument = gql`
    mutation UnfollowInvestmentOffer($emissionProcessId: ID!) {
  unfollowInvestmentOffer(emissionProcessId: $emissionProcessId) {
    id
    followerCount
  }
}
    `;
export type UnfollowInvestmentOfferMutationFn = Apollo.MutationFunction<UnfollowInvestmentOfferMutation, UnfollowInvestmentOfferMutationVariables>;

/**
 * __useUnfollowInvestmentOfferMutation__
 *
 * To run a mutation, you first call `useUnfollowInvestmentOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfollowInvestmentOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfollowInvestmentOfferMutation, { data, loading, error }] = useUnfollowInvestmentOfferMutation({
 *   variables: {
 *      emissionProcessId: // value for 'emissionProcessId'
 *   },
 * });
 */
export function useUnfollowInvestmentOfferMutation(baseOptions?: Apollo.MutationHookOptions<UnfollowInvestmentOfferMutation, UnfollowInvestmentOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnfollowInvestmentOfferMutation, UnfollowInvestmentOfferMutationVariables>(UnfollowInvestmentOfferDocument, options);
      }
export type UnfollowInvestmentOfferMutationHookResult = ReturnType<typeof useUnfollowInvestmentOfferMutation>;
export type UnfollowInvestmentOfferMutationResult = Apollo.MutationResult<UnfollowInvestmentOfferMutation>;
export type UnfollowInvestmentOfferMutationOptions = Apollo.BaseMutationOptions<UnfollowInvestmentOfferMutation, UnfollowInvestmentOfferMutationVariables>;
export const GetNumberOfInvestorsDocument = gql`
    query GetNumberOfInvestors {
  statisticsPageData {
    investors
  }
}
    `;

/**
 * __useGetNumberOfInvestorsQuery__
 *
 * To run a query within a React component, call `useGetNumberOfInvestorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNumberOfInvestorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNumberOfInvestorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNumberOfInvestorsQuery(baseOptions?: Apollo.QueryHookOptions<GetNumberOfInvestorsQuery, GetNumberOfInvestorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNumberOfInvestorsQuery, GetNumberOfInvestorsQueryVariables>(GetNumberOfInvestorsDocument, options);
      }
export function useGetNumberOfInvestorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNumberOfInvestorsQuery, GetNumberOfInvestorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNumberOfInvestorsQuery, GetNumberOfInvestorsQueryVariables>(GetNumberOfInvestorsDocument, options);
        }
export type GetNumberOfInvestorsQueryHookResult = ReturnType<typeof useGetNumberOfInvestorsQuery>;
export type GetNumberOfInvestorsLazyQueryHookResult = ReturnType<typeof useGetNumberOfInvestorsLazyQuery>;
export type GetNumberOfInvestorsQueryResult = Apollo.QueryResult<GetNumberOfInvestorsQuery, GetNumberOfInvestorsQueryVariables>;
export const GetPublishedCampaignCardsDocument = gql`
    query GetPublishedCampaignCards {
  getPublishedCampaignCards {
    ...PublishedCampaignCard
  }
}
    ${PublishedCampaignCardFragmentDoc}`;

/**
 * __useGetPublishedCampaignCardsQuery__
 *
 * To run a query within a React component, call `useGetPublishedCampaignCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublishedCampaignCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublishedCampaignCardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPublishedCampaignCardsQuery(baseOptions?: Apollo.QueryHookOptions<GetPublishedCampaignCardsQuery, GetPublishedCampaignCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublishedCampaignCardsQuery, GetPublishedCampaignCardsQueryVariables>(GetPublishedCampaignCardsDocument, options);
      }
export function useGetPublishedCampaignCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublishedCampaignCardsQuery, GetPublishedCampaignCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublishedCampaignCardsQuery, GetPublishedCampaignCardsQueryVariables>(GetPublishedCampaignCardsDocument, options);
        }
export type GetPublishedCampaignCardsQueryHookResult = ReturnType<typeof useGetPublishedCampaignCardsQuery>;
export type GetPublishedCampaignCardsLazyQueryHookResult = ReturnType<typeof useGetPublishedCampaignCardsLazyQuery>;
export type GetPublishedCampaignCardsQueryResult = Apollo.QueryResult<GetPublishedCampaignCardsQuery, GetPublishedCampaignCardsQueryVariables>;
export const MyReservedSubscriptionsDocument = gql`
    query MyReservedSubscriptions {
  myReservedSubscriptions {
    ...MyReservedSubscription
  }
}
    ${MyReservedSubscriptionFragmentDoc}`;

/**
 * __useMyReservedSubscriptionsQuery__
 *
 * To run a query within a React component, call `useMyReservedSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyReservedSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyReservedSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyReservedSubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<MyReservedSubscriptionsQuery, MyReservedSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyReservedSubscriptionsQuery, MyReservedSubscriptionsQueryVariables>(MyReservedSubscriptionsDocument, options);
      }
export function useMyReservedSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyReservedSubscriptionsQuery, MyReservedSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyReservedSubscriptionsQuery, MyReservedSubscriptionsQueryVariables>(MyReservedSubscriptionsDocument, options);
        }
export type MyReservedSubscriptionsQueryHookResult = ReturnType<typeof useMyReservedSubscriptionsQuery>;
export type MyReservedSubscriptionsLazyQueryHookResult = ReturnType<typeof useMyReservedSubscriptionsLazyQuery>;
export type MyReservedSubscriptionsQueryResult = Apollo.QueryResult<MyReservedSubscriptionsQuery, MyReservedSubscriptionsQueryVariables>;
export const WithdrawReservedSubscriptionDocument = gql`
    mutation WithdrawReservedSubscription($emissionProcessId: ID!, $reservedSubscriptionId: ID!, $reason: String!) {
  withdrawReservedSubscription(
    emissionProcessId: $emissionProcessId
    reservedSubscriptionId: $reservedSubscriptionId
    reason: $reason
  ) {
    id
    withdrawn
    withdrawnReason
  }
}
    `;
export type WithdrawReservedSubscriptionMutationFn = Apollo.MutationFunction<WithdrawReservedSubscriptionMutation, WithdrawReservedSubscriptionMutationVariables>;

/**
 * __useWithdrawReservedSubscriptionMutation__
 *
 * To run a mutation, you first call `useWithdrawReservedSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWithdrawReservedSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [withdrawReservedSubscriptionMutation, { data, loading, error }] = useWithdrawReservedSubscriptionMutation({
 *   variables: {
 *      emissionProcessId: // value for 'emissionProcessId'
 *      reservedSubscriptionId: // value for 'reservedSubscriptionId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useWithdrawReservedSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<WithdrawReservedSubscriptionMutation, WithdrawReservedSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WithdrawReservedSubscriptionMutation, WithdrawReservedSubscriptionMutationVariables>(WithdrawReservedSubscriptionDocument, options);
      }
export type WithdrawReservedSubscriptionMutationHookResult = ReturnType<typeof useWithdrawReservedSubscriptionMutation>;
export type WithdrawReservedSubscriptionMutationResult = Apollo.MutationResult<WithdrawReservedSubscriptionMutation>;
export type WithdrawReservedSubscriptionMutationOptions = Apollo.BaseMutationOptions<WithdrawReservedSubscriptionMutation, WithdrawReservedSubscriptionMutationVariables>;
export const UpdateReservedSubscriptionVpsAccountDocument = gql`
    mutation UpdateReservedSubscriptionVpsAccount($emissionProcessId: ID!, $reservedSubscriptionId: ID!, $vpsAccount: String!) {
  updateReservedSubscriptionVpsAccount(
    emissionProcessId: $emissionProcessId
    reservedSubscriptionId: $reservedSubscriptionId
    vpsAccount: $vpsAccount
  ) {
    id
    signee {
      vpsAccount
    }
  }
}
    `;
export type UpdateReservedSubscriptionVpsAccountMutationFn = Apollo.MutationFunction<UpdateReservedSubscriptionVpsAccountMutation, UpdateReservedSubscriptionVpsAccountMutationVariables>;

/**
 * __useUpdateReservedSubscriptionVpsAccountMutation__
 *
 * To run a mutation, you first call `useUpdateReservedSubscriptionVpsAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReservedSubscriptionVpsAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReservedSubscriptionVpsAccountMutation, { data, loading, error }] = useUpdateReservedSubscriptionVpsAccountMutation({
 *   variables: {
 *      emissionProcessId: // value for 'emissionProcessId'
 *      reservedSubscriptionId: // value for 'reservedSubscriptionId'
 *      vpsAccount: // value for 'vpsAccount'
 *   },
 * });
 */
export function useUpdateReservedSubscriptionVpsAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReservedSubscriptionVpsAccountMutation, UpdateReservedSubscriptionVpsAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReservedSubscriptionVpsAccountMutation, UpdateReservedSubscriptionVpsAccountMutationVariables>(UpdateReservedSubscriptionVpsAccountDocument, options);
      }
export type UpdateReservedSubscriptionVpsAccountMutationHookResult = ReturnType<typeof useUpdateReservedSubscriptionVpsAccountMutation>;
export type UpdateReservedSubscriptionVpsAccountMutationResult = Apollo.MutationResult<UpdateReservedSubscriptionVpsAccountMutation>;
export type UpdateReservedSubscriptionVpsAccountMutationOptions = Apollo.BaseMutationOptions<UpdateReservedSubscriptionVpsAccountMutation, UpdateReservedSubscriptionVpsAccountMutationVariables>;
export const GetPublishedCampaignCardByAliasDocument = gql`
    query GetPublishedCampaignCardByAlias($alias: String!) {
  publishedCampaignCardByAlias(alias: $alias) {
    ...PublishedCampaignCard
  }
}
    ${PublishedCampaignCardFragmentDoc}`;

/**
 * __useGetPublishedCampaignCardByAliasQuery__
 *
 * To run a query within a React component, call `useGetPublishedCampaignCardByAliasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublishedCampaignCardByAliasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublishedCampaignCardByAliasQuery({
 *   variables: {
 *      alias: // value for 'alias'
 *   },
 * });
 */
export function useGetPublishedCampaignCardByAliasQuery(baseOptions: Apollo.QueryHookOptions<GetPublishedCampaignCardByAliasQuery, GetPublishedCampaignCardByAliasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublishedCampaignCardByAliasQuery, GetPublishedCampaignCardByAliasQueryVariables>(GetPublishedCampaignCardByAliasDocument, options);
      }
export function useGetPublishedCampaignCardByAliasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublishedCampaignCardByAliasQuery, GetPublishedCampaignCardByAliasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublishedCampaignCardByAliasQuery, GetPublishedCampaignCardByAliasQueryVariables>(GetPublishedCampaignCardByAliasDocument, options);
        }
export type GetPublishedCampaignCardByAliasQueryHookResult = ReturnType<typeof useGetPublishedCampaignCardByAliasQuery>;
export type GetPublishedCampaignCardByAliasLazyQueryHookResult = ReturnType<typeof useGetPublishedCampaignCardByAliasLazyQuery>;
export type GetPublishedCampaignCardByAliasQueryResult = Apollo.QueryResult<GetPublishedCampaignCardByAliasQuery, GetPublishedCampaignCardByAliasQueryVariables>;
export const FinishedCampaignCardsDocument = gql`
    query FinishedCampaignCards($pagination: PaginationInput!, $filter: FinishedCampaignCardsFilterInput) {
  finishedAndArchivedCampaignCards(pagination: $pagination, filter: $filter) {
    id
    cards {
      ...FinishedCampaignCardData
    }
    filter {
      text
    }
    pagination {
      pageIndex
      pageSize
      total
      hasNext
      hasPrevious
    }
  }
}
    ${FinishedCampaignCardDataFragmentDoc}`;

/**
 * __useFinishedCampaignCardsQuery__
 *
 * To run a query within a React component, call `useFinishedCampaignCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinishedCampaignCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinishedCampaignCardsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFinishedCampaignCardsQuery(baseOptions: Apollo.QueryHookOptions<FinishedCampaignCardsQuery, FinishedCampaignCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinishedCampaignCardsQuery, FinishedCampaignCardsQueryVariables>(FinishedCampaignCardsDocument, options);
      }
export function useFinishedCampaignCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinishedCampaignCardsQuery, FinishedCampaignCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinishedCampaignCardsQuery, FinishedCampaignCardsQueryVariables>(FinishedCampaignCardsDocument, options);
        }
export type FinishedCampaignCardsQueryHookResult = ReturnType<typeof useFinishedCampaignCardsQuery>;
export type FinishedCampaignCardsLazyQueryHookResult = ReturnType<typeof useFinishedCampaignCardsLazyQuery>;
export type FinishedCampaignCardsQueryResult = Apollo.QueryResult<FinishedCampaignCardsQuery, FinishedCampaignCardsQueryVariables>;
export const GetActiveFrontPageCarouselItemsDocument = gql`
    query GetActiveFrontPageCarouselItems {
  getActiveFrontPageCarouselItems {
    id
    tag
    title
    subheader
    content
    buttonUrl
    backgroundImageUrl
    expiresAt
    animated
    darkThemed
  }
}
    `;

/**
 * __useGetActiveFrontPageCarouselItemsQuery__
 *
 * To run a query within a React component, call `useGetActiveFrontPageCarouselItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveFrontPageCarouselItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveFrontPageCarouselItemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveFrontPageCarouselItemsQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveFrontPageCarouselItemsQuery, GetActiveFrontPageCarouselItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveFrontPageCarouselItemsQuery, GetActiveFrontPageCarouselItemsQueryVariables>(GetActiveFrontPageCarouselItemsDocument, options);
      }
export function useGetActiveFrontPageCarouselItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveFrontPageCarouselItemsQuery, GetActiveFrontPageCarouselItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveFrontPageCarouselItemsQuery, GetActiveFrontPageCarouselItemsQueryVariables>(GetActiveFrontPageCarouselItemsDocument, options);
        }
export type GetActiveFrontPageCarouselItemsQueryHookResult = ReturnType<typeof useGetActiveFrontPageCarouselItemsQuery>;
export type GetActiveFrontPageCarouselItemsLazyQueryHookResult = ReturnType<typeof useGetActiveFrontPageCarouselItemsLazyQuery>;
export type GetActiveFrontPageCarouselItemsQueryResult = Apollo.QueryResult<GetActiveFrontPageCarouselItemsQuery, GetActiveFrontPageCarouselItemsQueryVariables>;
export const GetKeyStatisticFromIssuerApiDocument = gql`
    query GetKeyStatisticFromIssuerApi {
  statisticsPageData {
    raised
    investors
    companies
    fundedCampaigns
  }
}
    `;

/**
 * __useGetKeyStatisticFromIssuerApiQuery__
 *
 * To run a query within a React component, call `useGetKeyStatisticFromIssuerApiQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKeyStatisticFromIssuerApiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKeyStatisticFromIssuerApiQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetKeyStatisticFromIssuerApiQuery(baseOptions?: Apollo.QueryHookOptions<GetKeyStatisticFromIssuerApiQuery, GetKeyStatisticFromIssuerApiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKeyStatisticFromIssuerApiQuery, GetKeyStatisticFromIssuerApiQueryVariables>(GetKeyStatisticFromIssuerApiDocument, options);
      }
export function useGetKeyStatisticFromIssuerApiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKeyStatisticFromIssuerApiQuery, GetKeyStatisticFromIssuerApiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKeyStatisticFromIssuerApiQuery, GetKeyStatisticFromIssuerApiQueryVariables>(GetKeyStatisticFromIssuerApiDocument, options);
        }
export type GetKeyStatisticFromIssuerApiQueryHookResult = ReturnType<typeof useGetKeyStatisticFromIssuerApiQuery>;
export type GetKeyStatisticFromIssuerApiLazyQueryHookResult = ReturnType<typeof useGetKeyStatisticFromIssuerApiLazyQuery>;
export type GetKeyStatisticFromIssuerApiQueryResult = Apollo.QueryResult<GetKeyStatisticFromIssuerApiQuery, GetKeyStatisticFromIssuerApiQueryVariables>;
export const HasOpenInvestmentOffersDocument = gql`
    query HasOpenInvestmentOffers {
  hasOpenInvestmentOffers
}
    `;

/**
 * __useHasOpenInvestmentOffersQuery__
 *
 * To run a query within a React component, call `useHasOpenInvestmentOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasOpenInvestmentOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasOpenInvestmentOffersQuery({
 *   variables: {
 *   },
 * });
 */
export function useHasOpenInvestmentOffersQuery(baseOptions?: Apollo.QueryHookOptions<HasOpenInvestmentOffersQuery, HasOpenInvestmentOffersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasOpenInvestmentOffersQuery, HasOpenInvestmentOffersQueryVariables>(HasOpenInvestmentOffersDocument, options);
      }
export function useHasOpenInvestmentOffersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasOpenInvestmentOffersQuery, HasOpenInvestmentOffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasOpenInvestmentOffersQuery, HasOpenInvestmentOffersQueryVariables>(HasOpenInvestmentOffersDocument, options);
        }
export type HasOpenInvestmentOffersQueryHookResult = ReturnType<typeof useHasOpenInvestmentOffersQuery>;
export type HasOpenInvestmentOffersLazyQueryHookResult = ReturnType<typeof useHasOpenInvestmentOffersLazyQuery>;
export type HasOpenInvestmentOffersQueryResult = Apollo.QueryResult<HasOpenInvestmentOffersQuery, HasOpenInvestmentOffersQueryVariables>;
export const CreateDiscussionThreadDocument = gql`
    mutation CreateDiscussionThread($slug: String!, $input: CreateDiscussionThreadInput!) {
  createDiscussionThread(slug: $slug, input: $input) {
    id
    emissionProcessId
    discussions {
      ...DiscussionThreadData
    }
  }
}
    ${DiscussionThreadDataFragmentDoc}`;
export type CreateDiscussionThreadMutationFn = Apollo.MutationFunction<CreateDiscussionThreadMutation, CreateDiscussionThreadMutationVariables>;

/**
 * __useCreateDiscussionThreadMutation__
 *
 * To run a mutation, you first call `useCreateDiscussionThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDiscussionThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDiscussionThreadMutation, { data, loading, error }] = useCreateDiscussionThreadMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDiscussionThreadMutation(baseOptions?: Apollo.MutationHookOptions<CreateDiscussionThreadMutation, CreateDiscussionThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDiscussionThreadMutation, CreateDiscussionThreadMutationVariables>(CreateDiscussionThreadDocument, options);
      }
export type CreateDiscussionThreadMutationHookResult = ReturnType<typeof useCreateDiscussionThreadMutation>;
export type CreateDiscussionThreadMutationResult = Apollo.MutationResult<CreateDiscussionThreadMutation>;
export type CreateDiscussionThreadMutationOptions = Apollo.BaseMutationOptions<CreateDiscussionThreadMutation, CreateDiscussionThreadMutationVariables>;
export const CommentOnDiscussionThreadDocument = gql`
    mutation CommentOnDiscussionThread($slug: String!, $threadId: Int!, $content: String!) {
  commentOnDiscussionThread(slug: $slug, threadId: $threadId, content: $content) {
    id
    emissionProcessId
    discussions {
      ...DiscussionThreadData
    }
  }
}
    ${DiscussionThreadDataFragmentDoc}`;
export type CommentOnDiscussionThreadMutationFn = Apollo.MutationFunction<CommentOnDiscussionThreadMutation, CommentOnDiscussionThreadMutationVariables>;

/**
 * __useCommentOnDiscussionThreadMutation__
 *
 * To run a mutation, you first call `useCommentOnDiscussionThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommentOnDiscussionThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [commentOnDiscussionThreadMutation, { data, loading, error }] = useCommentOnDiscussionThreadMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      threadId: // value for 'threadId'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useCommentOnDiscussionThreadMutation(baseOptions?: Apollo.MutationHookOptions<CommentOnDiscussionThreadMutation, CommentOnDiscussionThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CommentOnDiscussionThreadMutation, CommentOnDiscussionThreadMutationVariables>(CommentOnDiscussionThreadDocument, options);
      }
export type CommentOnDiscussionThreadMutationHookResult = ReturnType<typeof useCommentOnDiscussionThreadMutation>;
export type CommentOnDiscussionThreadMutationResult = Apollo.MutationResult<CommentOnDiscussionThreadMutation>;
export type CommentOnDiscussionThreadMutationOptions = Apollo.BaseMutationOptions<CommentOnDiscussionThreadMutation, CommentOnDiscussionThreadMutationVariables>;
export const SetDiscussionThreadSubscriptionStatusDocument = gql`
    mutation SetDiscussionThreadSubscriptionStatus($slug: String!, $threadId: Int!, $subscribed: Boolean!) {
  setDiscussionThreadSubscriptionStatus(
    slug: $slug
    threadId: $threadId
    subscribed: $subscribed
  ) {
    id
    isSubscribed
  }
}
    `;
export type SetDiscussionThreadSubscriptionStatusMutationFn = Apollo.MutationFunction<SetDiscussionThreadSubscriptionStatusMutation, SetDiscussionThreadSubscriptionStatusMutationVariables>;

/**
 * __useSetDiscussionThreadSubscriptionStatusMutation__
 *
 * To run a mutation, you first call `useSetDiscussionThreadSubscriptionStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDiscussionThreadSubscriptionStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDiscussionThreadSubscriptionStatusMutation, { data, loading, error }] = useSetDiscussionThreadSubscriptionStatusMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      threadId: // value for 'threadId'
 *      subscribed: // value for 'subscribed'
 *   },
 * });
 */
export function useSetDiscussionThreadSubscriptionStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetDiscussionThreadSubscriptionStatusMutation, SetDiscussionThreadSubscriptionStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDiscussionThreadSubscriptionStatusMutation, SetDiscussionThreadSubscriptionStatusMutationVariables>(SetDiscussionThreadSubscriptionStatusDocument, options);
      }
export type SetDiscussionThreadSubscriptionStatusMutationHookResult = ReturnType<typeof useSetDiscussionThreadSubscriptionStatusMutation>;
export type SetDiscussionThreadSubscriptionStatusMutationResult = Apollo.MutationResult<SetDiscussionThreadSubscriptionStatusMutation>;
export type SetDiscussionThreadSubscriptionStatusMutationOptions = Apollo.BaseMutationOptions<SetDiscussionThreadSubscriptionStatusMutation, SetDiscussionThreadSubscriptionStatusMutationVariables>;
export const PublicInvestmentOfferBySlugDocument = gql`
    query PublicInvestmentOfferBySlug($slug: String!, $queryString: String, $includeEmission: Boolean = true, $includeDiscussion: Boolean = true, $includeTeamAndOwners: Boolean = true, $includeDocuments: Boolean = true, $isPreview: Boolean = false) {
  publishedCampaignCardByAlias(alias: $slug) {
    id
    caption
  }
  publicInvestmentOfferBySlug(slug: $slug, queryString: $queryString) {
    id
    title
    slug
    emissionProcessId
    maxSharesToIssue
    minSharesToIssue
    totalNumberOfShares
    maxSharesPerInvestor
    minSharesPerInvestor
    pricePerShare
    loanConversionSum
    companyAddress
    companyName
    organizationNumber
    vpsEnabled
    website
    singlePurposeVehicleEnabled
    emission {
      equityOffering {
        investmentLimits {
          minInvestmentInSharesPerInvestor
          maxInvestmentInSharesPerInvestor
        }
        companyValuation {
          numberOfShares
        }
      }
    }
    presentation {
      ...PublicPresentationData
    }
    dates {
      publish
      open
      close
    }
    emission @include(if: $includeEmission) {
      companyInfo {
        ...CompanyInfoData
      }
      financialInfo {
        ...FinancialInfoData
      }
      equityOffering {
        ...EquityOfferingData
      }
    }
    singlePurposeVehicle @include(if: $includeEmission) {
      ...SinglePurposeVehicleData
    }
    discussions @include(if: $includeDiscussion) {
      ...DiscussionThreadData
    }
    teamAndNetwork @include(if: $includeTeamAndOwners) {
      team {
        ...TeamAndNetworkMember
      }
      board {
        ...TeamAndNetworkMember
      }
      partners {
        ...TeamAndNetworkMember
      }
    }
    shareholders @include(if: $includeTeamAndOwners) {
      ...PublicShareholder
    }
    documents @include(if: $includeDocuments) {
      ...InvestmentOfferDocument
    }
    isInValidationPhase
    isPreview
    isReadonly
  }
  investmentOfferVisitor(slug: $slug) @skip(if: $isPreview) {
    ...InvestmentOfferVisitor
  }
}
    ${PublicPresentationDataFragmentDoc}
${CompanyInfoDataFragmentDoc}
${FinancialInfoDataFragmentDoc}
${EquityOfferingDataFragmentDoc}
${SinglePurposeVehicleDataFragmentDoc}
${DiscussionThreadDataFragmentDoc}
${TeamAndNetworkMemberFragmentDoc}
${PublicShareholderFragmentDoc}
${InvestmentOfferDocumentFragmentDoc}
${InvestmentOfferVisitorFragmentDoc}`;

/**
 * __usePublicInvestmentOfferBySlugQuery__
 *
 * To run a query within a React component, call `usePublicInvestmentOfferBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicInvestmentOfferBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicInvestmentOfferBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      queryString: // value for 'queryString'
 *      includeEmission: // value for 'includeEmission'
 *      includeDiscussion: // value for 'includeDiscussion'
 *      includeTeamAndOwners: // value for 'includeTeamAndOwners'
 *      includeDocuments: // value for 'includeDocuments'
 *      isPreview: // value for 'isPreview'
 *   },
 * });
 */
export function usePublicInvestmentOfferBySlugQuery(baseOptions: Apollo.QueryHookOptions<PublicInvestmentOfferBySlugQuery, PublicInvestmentOfferBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicInvestmentOfferBySlugQuery, PublicInvestmentOfferBySlugQueryVariables>(PublicInvestmentOfferBySlugDocument, options);
      }
export function usePublicInvestmentOfferBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicInvestmentOfferBySlugQuery, PublicInvestmentOfferBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicInvestmentOfferBySlugQuery, PublicInvestmentOfferBySlugQueryVariables>(PublicInvestmentOfferBySlugDocument, options);
        }
export type PublicInvestmentOfferBySlugQueryHookResult = ReturnType<typeof usePublicInvestmentOfferBySlugQuery>;
export type PublicInvestmentOfferBySlugLazyQueryHookResult = ReturnType<typeof usePublicInvestmentOfferBySlugLazyQuery>;
export type PublicInvestmentOfferBySlugQueryResult = Apollo.QueryResult<PublicInvestmentOfferBySlugQuery, PublicInvestmentOfferBySlugQueryVariables>;
export const PublicInvestmentOfferSummaryDocument = gql`
    query PublicInvestmentOfferSummary($slug: String!) {
  publicInvestmentOfferSummary(slug: $slug) {
    ...PublicInvestmentOfferSummaryData
  }
  mySubscriptionsSummaryBySlug(alias: $slug) {
    id
    mySubscriptionsCount
    myTotalSharesReserved
  }
}
    ${PublicInvestmentOfferSummaryDataFragmentDoc}`;

/**
 * __usePublicInvestmentOfferSummaryQuery__
 *
 * To run a query within a React component, call `usePublicInvestmentOfferSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicInvestmentOfferSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicInvestmentOfferSummaryQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function usePublicInvestmentOfferSummaryQuery(baseOptions: Apollo.QueryHookOptions<PublicInvestmentOfferSummaryQuery, PublicInvestmentOfferSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicInvestmentOfferSummaryQuery, PublicInvestmentOfferSummaryQueryVariables>(PublicInvestmentOfferSummaryDocument, options);
      }
export function usePublicInvestmentOfferSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicInvestmentOfferSummaryQuery, PublicInvestmentOfferSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicInvestmentOfferSummaryQuery, PublicInvestmentOfferSummaryQueryVariables>(PublicInvestmentOfferSummaryDocument, options);
        }
export type PublicInvestmentOfferSummaryQueryHookResult = ReturnType<typeof usePublicInvestmentOfferSummaryQuery>;
export type PublicInvestmentOfferSummaryLazyQueryHookResult = ReturnType<typeof usePublicInvestmentOfferSummaryLazyQuery>;
export type PublicInvestmentOfferSummaryQueryResult = Apollo.QueryResult<PublicInvestmentOfferSummaryQuery, PublicInvestmentOfferSummaryQueryVariables>;
export const PublicInvestmentOfferSummaryChangedDocument = gql`
    subscription PublicInvestmentOfferSummaryChanged($slug: String!) {
  publicInvestmentOfferSummaryChanged(slug: $slug) {
    ...PublicInvestmentOfferSummaryData
  }
}
    ${PublicInvestmentOfferSummaryDataFragmentDoc}`;

/**
 * __usePublicInvestmentOfferSummaryChangedSubscription__
 *
 * To run a query within a React component, call `usePublicInvestmentOfferSummaryChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePublicInvestmentOfferSummaryChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicInvestmentOfferSummaryChangedSubscription({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function usePublicInvestmentOfferSummaryChangedSubscription(baseOptions: Apollo.SubscriptionHookOptions<PublicInvestmentOfferSummaryChangedSubscription, PublicInvestmentOfferSummaryChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<PublicInvestmentOfferSummaryChangedSubscription, PublicInvestmentOfferSummaryChangedSubscriptionVariables>(PublicInvestmentOfferSummaryChangedDocument, options);
      }
export type PublicInvestmentOfferSummaryChangedSubscriptionHookResult = ReturnType<typeof usePublicInvestmentOfferSummaryChangedSubscription>;
export type PublicInvestmentOfferSummaryChangedSubscriptionResult = Apollo.SubscriptionResult<PublicInvestmentOfferSummaryChangedSubscription>;
export const PublicInvestmentOfferDiscussionChangedDocument = gql`
    subscription PublicInvestmentOfferDiscussionChanged($slug: String!) {
  publicInvestmentOfferDiscussionChanged(slug: $slug) {
    id
    discussions {
      ...DiscussionThreadData
    }
  }
}
    ${DiscussionThreadDataFragmentDoc}`;

/**
 * __usePublicInvestmentOfferDiscussionChangedSubscription__
 *
 * To run a query within a React component, call `usePublicInvestmentOfferDiscussionChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePublicInvestmentOfferDiscussionChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicInvestmentOfferDiscussionChangedSubscription({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function usePublicInvestmentOfferDiscussionChangedSubscription(baseOptions: Apollo.SubscriptionHookOptions<PublicInvestmentOfferDiscussionChangedSubscription, PublicInvestmentOfferDiscussionChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<PublicInvestmentOfferDiscussionChangedSubscription, PublicInvestmentOfferDiscussionChangedSubscriptionVariables>(PublicInvestmentOfferDiscussionChangedDocument, options);
      }
export type PublicInvestmentOfferDiscussionChangedSubscriptionHookResult = ReturnType<typeof usePublicInvestmentOfferDiscussionChangedSubscription>;
export type PublicInvestmentOfferDiscussionChangedSubscriptionResult = Apollo.SubscriptionResult<PublicInvestmentOfferDiscussionChangedSubscription>;
export const RegisterInvestmentOfferPageviewDocument = gql`
    mutation RegisterInvestmentOfferPageview($slug: String!) {
  registerInvestmentOfferPageview(slug: $slug)
}
    `;
export type RegisterInvestmentOfferPageviewMutationFn = Apollo.MutationFunction<RegisterInvestmentOfferPageviewMutation, RegisterInvestmentOfferPageviewMutationVariables>;

/**
 * __useRegisterInvestmentOfferPageviewMutation__
 *
 * To run a mutation, you first call `useRegisterInvestmentOfferPageviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterInvestmentOfferPageviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerInvestmentOfferPageviewMutation, { data, loading, error }] = useRegisterInvestmentOfferPageviewMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useRegisterInvestmentOfferPageviewMutation(baseOptions?: Apollo.MutationHookOptions<RegisterInvestmentOfferPageviewMutation, RegisterInvestmentOfferPageviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterInvestmentOfferPageviewMutation, RegisterInvestmentOfferPageviewMutationVariables>(RegisterInvestmentOfferPageviewDocument, options);
      }
export type RegisterInvestmentOfferPageviewMutationHookResult = ReturnType<typeof useRegisterInvestmentOfferPageviewMutation>;
export type RegisterInvestmentOfferPageviewMutationResult = Apollo.MutationResult<RegisterInvestmentOfferPageviewMutation>;
export type RegisterInvestmentOfferPageviewMutationOptions = Apollo.BaseMutationOptions<RegisterInvestmentOfferPageviewMutation, RegisterInvestmentOfferPageviewMutationVariables>;
export const SigneeTotalSharesCountInInvestmentOfferDocument = gql`
    query SigneeTotalSharesCountInInvestmentOffer($slug: String!, $organizationNumber: String) {
  signeeTotalSharesCountInInvestmentOffer(
    slug: $slug
    organizationNumber: $organizationNumber
  )
}
    `;

/**
 * __useSigneeTotalSharesCountInInvestmentOfferQuery__
 *
 * To run a query within a React component, call `useSigneeTotalSharesCountInInvestmentOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useSigneeTotalSharesCountInInvestmentOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSigneeTotalSharesCountInInvestmentOfferQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      organizationNumber: // value for 'organizationNumber'
 *   },
 * });
 */
export function useSigneeTotalSharesCountInInvestmentOfferQuery(baseOptions: Apollo.QueryHookOptions<SigneeTotalSharesCountInInvestmentOfferQuery, SigneeTotalSharesCountInInvestmentOfferQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SigneeTotalSharesCountInInvestmentOfferQuery, SigneeTotalSharesCountInInvestmentOfferQueryVariables>(SigneeTotalSharesCountInInvestmentOfferDocument, options);
      }
export function useSigneeTotalSharesCountInInvestmentOfferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SigneeTotalSharesCountInInvestmentOfferQuery, SigneeTotalSharesCountInInvestmentOfferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SigneeTotalSharesCountInInvestmentOfferQuery, SigneeTotalSharesCountInInvestmentOfferQueryVariables>(SigneeTotalSharesCountInInvestmentOfferDocument, options);
        }
export type SigneeTotalSharesCountInInvestmentOfferQueryHookResult = ReturnType<typeof useSigneeTotalSharesCountInInvestmentOfferQuery>;
export type SigneeTotalSharesCountInInvestmentOfferLazyQueryHookResult = ReturnType<typeof useSigneeTotalSharesCountInInvestmentOfferLazyQuery>;
export type SigneeTotalSharesCountInInvestmentOfferQueryResult = Apollo.QueryResult<SigneeTotalSharesCountInInvestmentOfferQuery, SigneeTotalSharesCountInInvestmentOfferQueryVariables>;
export const ReserveSubscriptionDocument = gql`
    mutation ReserveSubscription($emissionProcessId: ID!, $reservation: ReserveSubscriptionInput!, $signee: SigneeInput!) {
  reserveSubscription(
    emissionProcessId: $emissionProcessId
    reservation: $reservation
    signee: $signee
  ) {
    id
  }
}
    `;
export type ReserveSubscriptionMutationFn = Apollo.MutationFunction<ReserveSubscriptionMutation, ReserveSubscriptionMutationVariables>;

/**
 * __useReserveSubscriptionMutation__
 *
 * To run a mutation, you first call `useReserveSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReserveSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reserveSubscriptionMutation, { data, loading, error }] = useReserveSubscriptionMutation({
 *   variables: {
 *      emissionProcessId: // value for 'emissionProcessId'
 *      reservation: // value for 'reservation'
 *      signee: // value for 'signee'
 *   },
 * });
 */
export function useReserveSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<ReserveSubscriptionMutation, ReserveSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReserveSubscriptionMutation, ReserveSubscriptionMutationVariables>(ReserveSubscriptionDocument, options);
      }
export type ReserveSubscriptionMutationHookResult = ReturnType<typeof useReserveSubscriptionMutation>;
export type ReserveSubscriptionMutationResult = Apollo.MutationResult<ReserveSubscriptionMutation>;
export type ReserveSubscriptionMutationOptions = Apollo.BaseMutationOptions<ReserveSubscriptionMutation, ReserveSubscriptionMutationVariables>;
export const SendFeedbackDocument = gql`
    mutation SendFeedback($reservationId: ID!, $score: Int!, $comment: String) {
  sendFeedback(reservationId: $reservationId, score: $score, comment: $comment) {
    id
  }
}
    `;
export type SendFeedbackMutationFn = Apollo.MutationFunction<SendFeedbackMutation, SendFeedbackMutationVariables>;

/**
 * __useSendFeedbackMutation__
 *
 * To run a mutation, you first call `useSendFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendFeedbackMutation, { data, loading, error }] = useSendFeedbackMutation({
 *   variables: {
 *      reservationId: // value for 'reservationId'
 *      score: // value for 'score'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useSendFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<SendFeedbackMutation, SendFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendFeedbackMutation, SendFeedbackMutationVariables>(SendFeedbackDocument, options);
      }
export type SendFeedbackMutationHookResult = ReturnType<typeof useSendFeedbackMutation>;
export type SendFeedbackMutationResult = Apollo.MutationResult<SendFeedbackMutation>;
export type SendFeedbackMutationOptions = Apollo.BaseMutationOptions<SendFeedbackMutation, SendFeedbackMutationVariables>;
export const PublicReservedSubscriptionsListChangedDocument = gql`
    subscription PublicReservedSubscriptionsListChanged($slug: String!) {
  publicReservedSubscriptionsListChanged(slug: $slug) {
    id
    name
    shares
    createdAt
  }
}
    `;

/**
 * __usePublicReservedSubscriptionsListChangedSubscription__
 *
 * To run a query within a React component, call `usePublicReservedSubscriptionsListChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePublicReservedSubscriptionsListChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicReservedSubscriptionsListChangedSubscription({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function usePublicReservedSubscriptionsListChangedSubscription(baseOptions: Apollo.SubscriptionHookOptions<PublicReservedSubscriptionsListChangedSubscription, PublicReservedSubscriptionsListChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<PublicReservedSubscriptionsListChangedSubscription, PublicReservedSubscriptionsListChangedSubscriptionVariables>(PublicReservedSubscriptionsListChangedDocument, options);
      }
export type PublicReservedSubscriptionsListChangedSubscriptionHookResult = ReturnType<typeof usePublicReservedSubscriptionsListChangedSubscription>;
export type PublicReservedSubscriptionsListChangedSubscriptionResult = Apollo.SubscriptionResult<PublicReservedSubscriptionsListChangedSubscription>;
export const PublicReservedSubscriptionsDocument = gql`
    query PublicReservedSubscriptions($slug: String!) {
  publicReservedSubscriptionsList(slug: $slug) {
    id
    name
    shares
    createdAt
  }
}
    `;

/**
 * __usePublicReservedSubscriptionsQuery__
 *
 * To run a query within a React component, call `usePublicReservedSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicReservedSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicReservedSubscriptionsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function usePublicReservedSubscriptionsQuery(baseOptions: Apollo.QueryHookOptions<PublicReservedSubscriptionsQuery, PublicReservedSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicReservedSubscriptionsQuery, PublicReservedSubscriptionsQueryVariables>(PublicReservedSubscriptionsDocument, options);
      }
export function usePublicReservedSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicReservedSubscriptionsQuery, PublicReservedSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicReservedSubscriptionsQuery, PublicReservedSubscriptionsQueryVariables>(PublicReservedSubscriptionsDocument, options);
        }
export type PublicReservedSubscriptionsQueryHookResult = ReturnType<typeof usePublicReservedSubscriptionsQuery>;
export type PublicReservedSubscriptionsLazyQueryHookResult = ReturnType<typeof usePublicReservedSubscriptionsLazyQuery>;
export type PublicReservedSubscriptionsQueryResult = Apollo.QueryResult<PublicReservedSubscriptionsQuery, PublicReservedSubscriptionsQueryVariables>;
export const InitialLivePageDataForInvestmentOfferDocument = gql`
    query InitialLivePageDataForInvestmentOffer($slug: String!) {
  publicInvestmentOfferBySlug(slug: $slug) {
    id
    dates {
      open
      close
    }
    maxSharesToIssue
    minSharesToIssue
    pricePerShare
    title
    totalAmountReserved
    totalSharesReserved
    subscribersCount
    subscriptionsCount
  }
}
    `;

/**
 * __useInitialLivePageDataForInvestmentOfferQuery__
 *
 * To run a query within a React component, call `useInitialLivePageDataForInvestmentOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useInitialLivePageDataForInvestmentOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInitialLivePageDataForInvestmentOfferQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useInitialLivePageDataForInvestmentOfferQuery(baseOptions: Apollo.QueryHookOptions<InitialLivePageDataForInvestmentOfferQuery, InitialLivePageDataForInvestmentOfferQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InitialLivePageDataForInvestmentOfferQuery, InitialLivePageDataForInvestmentOfferQueryVariables>(InitialLivePageDataForInvestmentOfferDocument, options);
      }
export function useInitialLivePageDataForInvestmentOfferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InitialLivePageDataForInvestmentOfferQuery, InitialLivePageDataForInvestmentOfferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InitialLivePageDataForInvestmentOfferQuery, InitialLivePageDataForInvestmentOfferQueryVariables>(InitialLivePageDataForInvestmentOfferDocument, options);
        }
export type InitialLivePageDataForInvestmentOfferQueryHookResult = ReturnType<typeof useInitialLivePageDataForInvestmentOfferQuery>;
export type InitialLivePageDataForInvestmentOfferLazyQueryHookResult = ReturnType<typeof useInitialLivePageDataForInvestmentOfferLazyQuery>;
export type InitialLivePageDataForInvestmentOfferQueryResult = Apollo.QueryResult<InitialLivePageDataForInvestmentOfferQuery, InitialLivePageDataForInvestmentOfferQueryVariables>;
export const LivePageDataForInvestmentOfferDocument = gql`
    subscription LivePageDataForInvestmentOffer($slug: String!) {
  publicInvestmentOfferSummaryChanged(slug: $slug) {
    id
    subscriptionsCount
    totalSharesReserved
    subscribersCount
  }
}
    `;

/**
 * __useLivePageDataForInvestmentOfferSubscription__
 *
 * To run a query within a React component, call `useLivePageDataForInvestmentOfferSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLivePageDataForInvestmentOfferSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLivePageDataForInvestmentOfferSubscription({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useLivePageDataForInvestmentOfferSubscription(baseOptions: Apollo.SubscriptionHookOptions<LivePageDataForInvestmentOfferSubscription, LivePageDataForInvestmentOfferSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<LivePageDataForInvestmentOfferSubscription, LivePageDataForInvestmentOfferSubscriptionVariables>(LivePageDataForInvestmentOfferDocument, options);
      }
export type LivePageDataForInvestmentOfferSubscriptionHookResult = ReturnType<typeof useLivePageDataForInvestmentOfferSubscription>;
export type LivePageDataForInvestmentOfferSubscriptionResult = Apollo.SubscriptionResult<LivePageDataForInvestmentOfferSubscription>;
export const GetStatisticsPageDataFromIssuerApiDocument = gql`
    query GetStatisticsPageDataFromIssuerApi {
  statisticsPageData {
    raised
    campaigns
    companies
    investors
    campaignsThisYear
    raisedThisYear
    fundedCampaigns
  }
}
    `;

/**
 * __useGetStatisticsPageDataFromIssuerApiQuery__
 *
 * To run a query within a React component, call `useGetStatisticsPageDataFromIssuerApiQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatisticsPageDataFromIssuerApiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatisticsPageDataFromIssuerApiQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStatisticsPageDataFromIssuerApiQuery(baseOptions?: Apollo.QueryHookOptions<GetStatisticsPageDataFromIssuerApiQuery, GetStatisticsPageDataFromIssuerApiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStatisticsPageDataFromIssuerApiQuery, GetStatisticsPageDataFromIssuerApiQueryVariables>(GetStatisticsPageDataFromIssuerApiDocument, options);
      }
export function useGetStatisticsPageDataFromIssuerApiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStatisticsPageDataFromIssuerApiQuery, GetStatisticsPageDataFromIssuerApiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStatisticsPageDataFromIssuerApiQuery, GetStatisticsPageDataFromIssuerApiQueryVariables>(GetStatisticsPageDataFromIssuerApiDocument, options);
        }
export type GetStatisticsPageDataFromIssuerApiQueryHookResult = ReturnType<typeof useGetStatisticsPageDataFromIssuerApiQuery>;
export type GetStatisticsPageDataFromIssuerApiLazyQueryHookResult = ReturnType<typeof useGetStatisticsPageDataFromIssuerApiLazyQuery>;
export type GetStatisticsPageDataFromIssuerApiQueryResult = Apollo.QueryResult<GetStatisticsPageDataFromIssuerApiQuery, GetStatisticsPageDataFromIssuerApiQueryVariables>;
export const UnfollowInvestmentOfferByEmailLinkDocument = gql`
    mutation UnfollowInvestmentOfferByEmailLink($token: String!) {
  unfollowInvestmentOfferFromEmailLink(token: $token)
}
    `;
export type UnfollowInvestmentOfferByEmailLinkMutationFn = Apollo.MutationFunction<UnfollowInvestmentOfferByEmailLinkMutation, UnfollowInvestmentOfferByEmailLinkMutationVariables>;

/**
 * __useUnfollowInvestmentOfferByEmailLinkMutation__
 *
 * To run a mutation, you first call `useUnfollowInvestmentOfferByEmailLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfollowInvestmentOfferByEmailLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfollowInvestmentOfferByEmailLinkMutation, { data, loading, error }] = useUnfollowInvestmentOfferByEmailLinkMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useUnfollowInvestmentOfferByEmailLinkMutation(baseOptions?: Apollo.MutationHookOptions<UnfollowInvestmentOfferByEmailLinkMutation, UnfollowInvestmentOfferByEmailLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnfollowInvestmentOfferByEmailLinkMutation, UnfollowInvestmentOfferByEmailLinkMutationVariables>(UnfollowInvestmentOfferByEmailLinkDocument, options);
      }
export type UnfollowInvestmentOfferByEmailLinkMutationHookResult = ReturnType<typeof useUnfollowInvestmentOfferByEmailLinkMutation>;
export type UnfollowInvestmentOfferByEmailLinkMutationResult = Apollo.MutationResult<UnfollowInvestmentOfferByEmailLinkMutation>;
export type UnfollowInvestmentOfferByEmailLinkMutationOptions = Apollo.BaseMutationOptions<UnfollowInvestmentOfferByEmailLinkMutation, UnfollowInvestmentOfferByEmailLinkMutationVariables>;
export const MyEmissionProcessesInNewIssuerDocument = gql`
    query MyEmissionProcessesInNewIssuer {
  myEmissionProcesses {
    id
  }
}
    `;

/**
 * __useMyEmissionProcessesInNewIssuerQuery__
 *
 * To run a query within a React component, call `useMyEmissionProcessesInNewIssuerQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyEmissionProcessesInNewIssuerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyEmissionProcessesInNewIssuerQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyEmissionProcessesInNewIssuerQuery(baseOptions?: Apollo.QueryHookOptions<MyEmissionProcessesInNewIssuerQuery, MyEmissionProcessesInNewIssuerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyEmissionProcessesInNewIssuerQuery, MyEmissionProcessesInNewIssuerQueryVariables>(MyEmissionProcessesInNewIssuerDocument, options);
      }
export function useMyEmissionProcessesInNewIssuerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyEmissionProcessesInNewIssuerQuery, MyEmissionProcessesInNewIssuerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyEmissionProcessesInNewIssuerQuery, MyEmissionProcessesInNewIssuerQueryVariables>(MyEmissionProcessesInNewIssuerDocument, options);
        }
export type MyEmissionProcessesInNewIssuerQueryHookResult = ReturnType<typeof useMyEmissionProcessesInNewIssuerQuery>;
export type MyEmissionProcessesInNewIssuerLazyQueryHookResult = ReturnType<typeof useMyEmissionProcessesInNewIssuerLazyQuery>;
export type MyEmissionProcessesInNewIssuerQueryResult = Apollo.QueryResult<MyEmissionProcessesInNewIssuerQuery, MyEmissionProcessesInNewIssuerQueryVariables>;